export default {
  es: {
    guardar: "Guardar",
    volver: "< Volver",
    sin_definir: "Sin definir",
    guardar_datos: "Guardar datos",
    cancelar: "Cancelar",
    confirmar: "Confirmar",
    eliminar: "Eliminar",
    aceptar: "Aceptar",
    rechazar: "Rechazar",
    comenzar: "Comenzar",
    cerrar_sesion: "Cerrar sesión",
    ver_menos: "Ver menos",
    ver_mas: "Ver más",
    inicio: "Inicio",
    ver_detalles: "Ver detalles",
    guardar: "Guardar",
    editar: "Editar",
    anadir: "Añadir",
    enviar: "Enviar",
    requerido: "Requerido",
    revisar: "Revisar",
    editar_oferta: "Editar oferta",
    duplicar_oferta: "Duplicar oferta",
    cerrar_oferta: "Cerrar oferta",
    eliminar_oferta: "Eliminar oferta",
    ver_como_candidato: "Ver como candidato",
    practicas: "Prácticas",
    empleo: "Empleo",
    ver: "Ver",
    enlaces: {
      politica_privacidad: "/politica-de-privacidad",
      politica_cookies: "/politica-de-cookies",
      login: "/login",
      solicitar_cuenta: "/solicitar-cuenta",
      registroalumno: "/registroalumno",
      encuestas: "/encuestas",
      encuesta: "/encuesta",
      eventos: "/eventos",
      eventospublico: "/evento-publico",
      documentacion: "/documentacion",
      guiaOrientacion: "/guias-orientacion",
      ofertas_practicas: "/ofertas-practicas",
      ofertas_empleo: "/ofertas-empleo",
      cv: "/cv",
      vercv: "/ver-cv",
      mis_candidaturas: "/mis-candidaturas",
      mis_practicas: "/mis-practicas",
      orientacion: "/orientacion-laboral",
      propuesta_practicas: "/propuesta-practicas",
      programapracticasactivos: "/programas-practicas-activos",
      solicitarcambiopracticas: "/solicitar-cambio-practicas",
      subirconvenio: "/subir-convenio-firmado",
      generarnuevoconvenio: "/nuevo-convenio-colaboracion",
      practicaseducacion: "/solicitudes-practicas-educacion",
      nueva_oferta: "/nueva-oferta",
      editar_oferta: "/editar-oferta",
      mi_empresa: "/mi-empresa",
      mi_perfil: "/mi-perfil",
      mis_ofertas: "/mis-ofertas",
      mi_oferta: "/oferta",
      programa_practicas: "/programa-practicas",
      visualizar_oferta: "/visualizar-oferta",
      restablecer_login: "/restablecer-login",
      restablecer_candidato: "/restablecer-candidato",
      setear_pass: "/establecer-login",
      proteccion_datos: "/proteccion-de-datos",
      acceso_saml: "/acceso",
      logout: "/logout",
      ayuda: "/ayuda",
      condicionespracticasuib: "/EUNCET/condiciones-practicas",
      formulario_datos: "/formulario-datos",
    },
    encabezado: {
      home: "Portal de empleo y prácticas",
      cv: "Mi currículum",
      cv_view: "Currículum del candidato",
      eventos: "Eventos",
      propuesta_practicas: "Propuesta de prácticas",
      politica_privacidad: "Política de privacidad",
      politica_cookies: "Política de cookies",
      login: "Inicio de sesión",
      solicitar_cuenta: "Nueva empresa",
      registro_alumno: "Registro",
      ofertas_practicas: "Listado de ofertas de prácticas",
      ofertas_empleo: "Listado de ofertas de empleo",
      ficha_oferta_alumno_empleo: "Listado de ofertas de empleo",
      ficha_oferta_alumno_practicas: "Listado de ofertas de prácticas",
      mis_candidaturas: "Mis candidaturas",
      mis_practicas: "Mis prácticas",
      encuestas: "Encuestas",
      orientacion: "Orientación laboral",
      nueva_oferta: "Nueva oferta",
      editar_oferta: "Editar oferta",
      mi_empresa: "Mi empresa",
      mi_perfil: "Mi perfil",
      documentacion: "Documentación",
      guiasOrientacion: "Guías Orientación",
      documentacion_empresa: "Documentación",
      documentacion_alumno: "Mi documentación",
      mis_ofertas: "Mis ofertas",
      mi_oferta: "Mi oferta",
      ficha_oferta_empresa: "Mi oferta",
      restablecer_login: "Restablecer Contraseña",
      restablecer_candidato: "Restablecer Contraseña",
      programapracticasactivos: "Programas de prácticas activos",
      setear_pass: "Establecer Contraseña",
      proteccion_datos: "Protección de datos",
      visor_oferta: "Ver como estudiante",
      fichaProgramaActivo: "Programas activos",
      solicitudCambioPracticas: "Solicitud cambio de prácticas",
      solicitudesEducacion: "Solicitudes ofertas educación",
      subirConvenioFirmado: "Subir convenio firmado",
      generarNuevoConvenio: "Nuevo convenio de Colaboración",
      ayuda: "Ayuda",
      condicionespracticasuib: "Condiciones prácticas",
      info_alumno:
        "Recuerda que si quieres realizar prácticas hasta el 15 de septiembre no debes solicitar el título hasta pasada dicha fecha. En el caso de solicitar el título antes del 15 de septiembre perderás la condición de estudiante y ya no podrás realizar prácticas.",
      formulario_datos: "Formulario datos",
      formulario_incorporacion: "Formulario de incorporación",
      falta_num_ss:
        "Debido a la entrada en vigor del nuevo RD el real decreto-ley 2/2023, de 16 de marzo, que entró en vigor el 1 de enero 2024, es OBLIGATORIO que nos facilites tu número de afiliación a la Seguridad Social. Accede a tu perfil para cumplimentar esta información.",
    },
    ficha_oferta: {
      texto_programa_anadido:
        "Tienes este programa añadido a tu lista de programas informáticos",
    },
    formulario: {
      nombre: "Nombre",
      nombre_apellidos: "Nombre y apellidos",
      apellidos: "Apellidos",
      email: "Email",
      mensaje: "Mensaje",
      fecha_nacimiento: "Fecha de nacimiento",
      dia: "Día",
      mes: "Mes",
      anyo: "Año",
      area_interes: "Área de su interés",
      trabaja_actualmente: "¿Trabaja actualmente?",
      si: "Si",
      no: "No",
      carta_presentacion: "Carta de presentacion",
      meses: {
        Enero: "Enero",
        Febrero: "Febrero",
        Marzo: "Marzo",
        Abril: "Abril",
        Mayo: "Mayo",
        Junio: "Junio",
        Julio: "Julio",
        Agosto: "Agosto",
        Septiembre: "Septiembre",
        Octubre: "Octubre",
        Noviembre: "Noviembre",
        Diciembre: "Diciembre",
      },
      archivo_adjunto: "Adjuntar archivo",
      adjuntar_cv: "Adjuntar CV",
      introduce_mail: "Introduce tu email",
      pais: "País",
      telefono: "Teléfono",
      he_leido: "He leído y acepto la",
      y_acepto: "política de privacidad",
      enviar: "Enviar",
      enviado: "Enviado",
    },
    meses: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    login: {
      iniciar_sesion: "LOGIN",
      acceder: "Acceder",
      email: "Email",
      error_mail:
        "Por favor, indica el mismo email que figura en tu acceso al Campus de Euncet para acceder en el portal.",
      contrasena: "Contraseña",
      repetir_contrasena: "Repetir Contraseña",
      contrasena_olvidada: "Generar / recuperar contraseña",
      introduce_email: "Introduce tu email",
      email_mal: "",
      recuperar_pass: "Recuperar mi contraseña",
      aun_no_registrado: "¿Aún no estas registrado/a?",
      acceder_SSO: "",
      indica_mail:
        "Por favor, indica tu <strong>{{$t(oferta.email)}}</strong> para logarte en el portal.",
      selecciona_empresa:
        "Por favor, selecciona la empresa con la que quieres acceder.",
      titulacion: "Titulación",
      tipo_formacion: "Tipo de formación academica",
      selecciona_formacion: "Selecciona un tipo de formación",
      registrarme: "Registrarme",
      deseo_recibir:
        "Deseo recibir comunicaciones relacionadas con EUNCET y con servicios relacionados con formación superior.",
      popup_rgpd: {
        titulo: "INFORMACIÓN AMPLIADA",
        detalle:
          "Si necesitas ampliar información más detallada, puedes acceder a la Política de Protección de Datos en ",
        enlace: "este enlace.",
        boton: "Consiento, acceder",
      },
      restablecer_pass: {
        titulo: "Sigue los pasos para restablecer tu contraseña",
        intro: "La contraseña debe contener al menos 8 caracteres y un número.",
        guardar: "Guardar",
      },
      seteo_pass: {
        titulo: "Sigue los pasos para establecer tu contraseña",
        intro: "La contraseña debe contener al menos 8 caracteres y un número.",
        guardar: "Guardar",
      },
    },
    registro: {
      encabezado:
        "Cumplimenta el formulario que hay a continuación para darte de alta en el sistema",
      datos_usuario: "Datos del usuario de empresa",
      datos_personales: "Datos personales",
      nombre: "Nombre",
      apellidos: "Apellidos",
      DNI: "DNI/NIF/NIE",
      CIF: "CIF de la empresa",
      puesto: "Puesto / Cargo",
      departamento: "Departamento",
      telefono_1: "Teléfono 1",
      telefono_2: "Teléfono 2",
      email: "Email",
      sede: "Sede por defecto",
      cargo: "Cargo",
      idioma: "Idioma preferido de comunicación",
      tipo_contacto: "Tipo de Contacto",
      contrasena: "Contraseña",
      repetir_contrasena: "Repetir Contraseña",
      direccion: "Dirección",
      pais: "País",
      selecciona_pais: "-selecciona un país-",
      provincia: "Provincia",
      selecciona_provincia: "-Selecciona una provincia-",
      localidad: "Localidad",
      selecciona_localidad: "-Selecciona una localidad-",
      direccion: "Dirección",
      direccion_empresa: "Dirección Empresa",
      cp: "Código Postal",
      titulo_2:
        "A continuación introduce los datos de tu empresa para darte de alta en el sistema",
      anadir_imagen: "Haz click para añadir la imagen",
      autorizar_logo: "Autorizar uso del logo",
      nombre_fiscal: "Nombre fiscal o Razón social",
      cp: "Código postal",
      email_empresa: "Email de empresa",
      nombre_comercial: "Nombre comercial",
      tipo_sociedad: "Tipo de Sociedad",
      selecciona_tipo_sociedad: "-Selecciona tipo de sociedad-",
      tipo_empresa: "Tipo de Empresa",
      privada: "Privada",
      publica: "Pública",
      startup: "Startup",
      eliminar: "Eliminar",
      descripcion: "Descripción",
      si: "Sí",
      no: "No",
      sector: "Sector",
      selecciona_sector: "-Selecciona un sector-",
      otro_sector: "Otro Sector",
      numero_empleados: "Número de empleados",
      selecciona_empleados: "-Selecciona un rango-",
      web: "Web",
      iban: "Número cuenta IBAN",
      descripcion_empresa: "Descripción de la empresa",
      femenino: "Femenino",
      masculino: "Masculino",
      telefono: "Teléfono",
      firmante: {
        titulo:
          "A continuación introduce los datos de la persona que actúa como representante legal de la empresa y que será quien firmará los convenios",
        no_obligatorio: "(no es obligatorio, se puede indicar más adelante)​",
        nombre: "Nombre del firmante",
        apellidos: "Apellidos del firmante",
        email: "Email del firmante",
        dni: "DNI del firmante",
        cargo: "Cargo del firmante",
        telefono: "Teléfono",
      },
      contacto: {
        nombre: "Nombre del contacto",
        apellidos: "Apellidos del contacto",
        email: "Email del contacto",
        telefono: "Teléfono",
      },
      envio_facturas: {
        titulo: "Dirección envío de facturas",
        titulo_2: "Dirección de facturación",
      },
      anadir_direccion: "Añadir nueva dirección de facturación",
      perfil_sectorial: "Perfil sectorial",
      sector_actividad: "Sector de actividad",
      selecciona_sector_actividad: "-Selecciona un sector-",
      rango: "Rango de facturación",
      selecciona_rango: "-Selecciona un rango-",
      numero_empleados: "Número de empleados",
      selecciona_numero_empleados: "-Selecciona un rango-",
      anyo_fundacion: "Año de fundación",
      politica_1: "He leído y acepto la,",
      politica_2: "política de privacidad",
      nuevo_contacto_titulo: "Datos del nuevo contacto de gestión",
      anadir_contacto: "Añadir contacto",
      nueva_cuenta_fiscal: "Datos de la cuenta nueva fiscal",
      domicilio_fiscal: "Domicilio Fiscal",
      poblacion: "Población",
      requiere_envio_postal: "Requiere envío postal de las facturas",
      domicilio_postal: "Domicilio para el envío postal de facturas",
      anadir_cuenta: "Añadir cuenta",
      datos_firmante: "Datos del firmante",
      area_conocimiento: "Área o rama de conocimiento",
      nombre_titulacion: "Nombre de la titulación",
      ano_inicio: "Año de inicio",
      ano_finalizacion: "Año de finalización",
      solicitar_cuenta: "Solicitar cuenta",
      seguir_empresa: "Seguir con los datos de la empresa",
      registrar_empresa: "Registrar Empresa",
      dni_pasaporte_nie: "DNI/NIF/NIE/Pasaporte",
      selecciona_nivel: "-Selecciona un nivel-",
      busca_area: "Busca el área",
      busca_titulacion: "Busca la titulación",
      firmaDigital: "Tipo de firma para el convenio ",
      asume_coste_SS:
        "¿Su entidad acepta asumir el cumplimiento, gestión y coste de las obligaciones en materia de Seguridad Social de los estudiantes que realicen prácticas formativas o prácticas académicas externas en su institución, tal y como recoge el Real Decreto-ley 2/2023?",
      asume_coste_SS_Si:
        "Si, aceptamos asumir el cumplimiento, gestión y coste de las obligaciones de la Seguridad Social del estudiante, en el momento que sea de aplicación efectiva tal y como recoge el Real Decreto-ley 2/2023.",
      asume_coste_SS_No:
        "No Aceptamos. Solicitamos que sea EUNCET, la entidad que asuma el cumplimiento, gestión y coste de las obligaciones de la Seguridad Social del estudiante, en el momento que sea de aplicación efectiva tal y como recoge el Real Decreto-ley 2/2023.",
    },
    home_empresa: {
      ofertas_practicas: "OFERTAS<strong>De prácticas</strong>",
      texto_ofertas_practicas:
        "Consulta y gestiona las ofertas de prácticas y las candidaturas recibidas.",
      nueva_practicas: "PUBLICAR<strong>Nueva oferta de prácticas",
      publicar_practicas:
        "Publica ofertas de prácticas, dirigidas a nuestros/as estudiantes",
      nueva_propuesta: "SOLICITAR PRÁCTICA<strong>Propuesta de prácticas",
      publicar_propuesta:
        "Si ya tienes seleccionada la persona que va a realizar la práctica, haz tu propuesta de prácticas para este/a estudiante aquí.",
      ofertas_empleo: "OFERTAS<strong>De empleo",
      texto_ofertas_empleo:
        "Consulta y gestiona las ofertas de empleo y las candidaturas recibidas.",
      nueva_empleo: "PUBLICAR<strong>Nueva oferta de empleo",
      texto_nueva_empleo: "Publica ofertas de empleo.",
    },
    mi_practica: {
      subir_documentacion: "Subir documentación",
      descargar_anexo: "Descargar Anexo Firmado",
      descargar_certificado:
        "Descargar certificado de realización de prácticas",
      descargar_poliza: "Descargar póliza del seguro",
      titulo_practicas:
        "Para poder incorporarte a la realización de estas prácticas es necesario",
      pagar_creditos: "Pagar los créditos que se van a reconocer.",
      descarga: "Descarga",
      aqui: "aquí",
      documento_pago:
        "el documento de Carta de Pago con la información de cantidades debidas e instrucciones.",
      contratar_poliza:
        "Contratar una póliza de accidentes que te cubra estas prácticas",
      puedes_contratar:
        "Puedes contratar cualquier póliza de seguro, si lo deseas puedes contratar online",
      mensaje_documentos:
        "Una vez tengas <strong>listos</strong> los documentos, por favor <strong>digitalízalos y adjúntalos</strong> a continuación. Revisaremos que son válidos antes de firmar el contrato con la empresa.",
      digitaliza_documentos:
        "Una vez tengas <strong>listo</strong> el documento, por favor <strong>digitalízalo y adjúntalo</strong> a continuación. Revisaremos que es válido antes de firmar el contrato con la empresa.",
      adjuntar_pago: "Adjuntar resguardo de pago",
      adjuntar_seguro: "Adjuntar póliza de seguro",
      descarga_ficheros:
        "Descarga los siguientes ficheros, firmalos y adjuntalos de nuevo.",
      enviar: "Enviar",
      renuncia_practicas_SET:
        "Estas prácticas extracurriculares formarán parte de tu SET (Suplemento Europeo al Título) si cumples los requisitos exigidos legalmente, en caso de que no desees que se unan a SET, debes adjuntar documento de renuncia firmado. Puedes descargar la plantilla del documento",
      adjuntar_renuncia: "Adjuntar renuncia firmada",
    },
    mis_practicas: {
      titulo:
        "En esta sección encontrarás toda la documentación referente a tus prácticas.",
      zero_1:
        "No hay ninguna práctica o documentación de prácticas para mostrar.",
    },
    cambio_password: {
      titulo: "Cambiar contraseña",
      titulo_candidato: "¿Deseas cambiar tu contraseña?",
      contrasena_actual: "Contraseña actual",
      nueva_contrasena: "Nueva Contraseña",
      repetir_contrasena: "Repetir nueva Contraseña",
    },
    guia_orientacion: {
      titulo:
        "A continuación ponemos a tu disposición documentos en relación con tus prácticas o empleo, consejos y buenas prácticas que pueden ser de tu interés.",
      zero: "No hay guias de orientación",
    },
    mi_empresa: {
      intro: {
        cuerpo:
          "Se muestran a continuación los datos principales de su empresa. Si alguno no es correcto, o necesita acceder, corregir, o eliminar cualquier detalle de su información envie un e-mail a careers.services@euncet.com.",
        porfavor: "Si tiene cualquier duda, por favor, ",
        contacte: "contacte con nosotros.",
      },
      datos_empresa: "Datos de la empresa",
    },
    formulario_datos: {
      intro: {
        cuerpo:
          "Se muestran a continuación los datos principales de su empresa. Actualice o cumplimente la siguiente información sobre su empresa.",
        porfavor: "Por favor, ",
        contacte: "contacte con nosotros.",
      },
      datos_empresa: "Datos de la empresa",
      datos_firmante: "Datos del firmante",
      datos_contacto: "Datos del contacto",
    },
    candidaturas_options: {
      aceptar: "Aceptar inscripción",
      rechazar: "Rechazar inscripción",
      motivos_rechazo: "Motivos del rechazo",
      selecciona_motivo: "- Selecciona un motivo de rechazo -",
      rechazar_preinscripcion: "Rechazar preinscripción a la oferta",
    },
    oferta: {
      intro_editor:
        "Para crear una oferta nueva debe cumplimentar el formulario que hay a continuación",
      tipo_oferta: "Tipo de oferta",
      numero_plazas: "Número de plazas",
      experiencia: "Experiencia",
      experiencia_deseable: "Experiencia deseable",
      horario: "Horario",
      fecha_inicio: "Fecha de inicio",
      fecha_fin: "Fecha de finalización",
      tipo_contrato: "Tipo de contrato",
      salario: "Salario",
      creditos: "Créditos superados",
      otras_remuneraciones: "Otras remuneraciones",
      pais: "País",
      poblacion: "Población/Provincia",
      poblacion_only: "Población",
      provincia: "Provincia",
      sector: "Sector de la empresa",
      categoria: "Categoria",
      area_funcional: "Área funcional",
      seleccione_provincia: "-Selecciona una provincia-",
      sede: "Sede/campus",
      beca: "Beca mensual",
      descripcion_puesto: "Descripción del puesto",
      tarea: "Tarea",
      tutores_disponibles: "Tutores disponibles",
      otras_tareas: "Otras tareas",
      programa_practicas: "Programa de prácticas",
      aviso_programa:
        "Importante consultar para comprobar requisitos obligatorios",
      enlace_inscripcion: "Enlace de inscripción",
      ir_enlace: "Ir al enlace",
      idiomas: "Idiomas",
      anadir_idiomas: "Añadir Idiomas",
      empleo: "Empleo",
      practicas: "Prácticas",
      certificacion: "Certificación mínima requerida",
      requerido: "Requerido",
      estudios_obligatorios: "Estudios a los que va dirigido",
      estudios_deseables: "Estudios deseables",
      estudios_propuestos: "Estudios propuestos",
      requisitos_obligatorios: "Requisitos obligatorios",
      etiquetas: "Etiquetas",
      otros_obligatorios: "Otros obligatorios",
      edad_maxima: "Edad máxima",
      salario_maximo: "Salario Máximo",
      intereses_deseables: "Intereses deseables",
      intereses_obligatorios: "Intereses obligatorios",
      intereses_seleccionados: "Intereses seleccionados",
      competencias_obligatorias: "Competencias obligatorias",
      competencias_seleccionadas: "Competencias seleccionadas",
      paises_nacionalidad_obigatorios: "Paises de Nacionalidad obligatorios",
      paises_residencia_obligatorios: "Paises de Residencia obligatorios",
      provincia_residencia_obligatorios: "Provincia de Residencia obligatorios",
      paises_seleccionados: "Paises seleccionados",
      provincias_seleccionados: "Provincias seleccionadas",
      coche_propio: "Coche propio",
      obligatorio_quest: "¿Obligatorio?",
      carnet_conducir: "Carnet de conducir",
      disponible_extranjero: "Disponibilidad para trabajar en el extranjero",
      disponible_residencia: "Disponibilidad para cambio de residencia",
      trabajando_actualmente: "Trabajando actualmente",
      requisitos_deseables: "Requisitos deseables",
      otros_requisitos_deseables: "Otros Requisitos deseables",
      otros_requisitos_obligatorios: "Otros requisitos obligatorios",
      motivos_exclusion: "Motivos de exclusión",
      competencias_deseables: "Competencias deseables",
      paises_nacionalidad_deseables: "Paises de Nacionalidad deseables",
      paises_residencia_deseables: "Paises de Residencia deseables",
      provincia_residencia_deseables: "Provincia de Residencia deseables",
      programas_informaticos: "Programas informáticos",
      programas_informaticos_deseables: "Programas informáticos deseables",
      documentos_requeridos: "Documentos requeridos",
      documentos: "Documentos",
      marca_documentos:
        "Marca los documentos que deben aportar los candidatos/as.",
      anadir_otro_documento: "Añadir otro tipo de documento",
      nombre_documento_candidato:
        "Nombre del documento a aportar por el candidato",
      inscribirme: "Inscribirme",
      desinscribirme: "Desinscribirme",
      ya_inscrito: "ya estas inscrito",
      cancelar_inscripcion: "Cancelar inscripción",
      buscar_mas_intereses: "Busca más intereses",
      atencion: "¡Atención!",
      tramitar_inscripcion:
        "Para tramitar tu inscripción en esta oferta debes presentar tu candidatura en la web de la empresa ofertante.",
      acceder: "Para acceder",
      pincha_aqui: "pincha aquí.",
      especialidad: "Especialidad",
      estado: "Estado",
      datos_practica: "Datos de la práctica",
      paso_4: "Paso 4 de 4",
      tareas_a_desarrollar: "Tareas a desarrollar",
      horario: "Horario",
      horario_practicas: "Horario de prácticas",
      horario_trabajo: "Horario de trabajo",
      tengo_candidato: "Tengo candidato/a",
      horas_dia: "Horas al día",
      horas_semana: "Horas semanales",
      remuneracion: "Remuneración (€ brutos/hora)",
      remuneracion_anual: "Remuneración bruta anual",
      otros_beneficios: "Otros beneficios",
      fecha_inicio: "Fecha de inicio",
      fecha_fin: "Fecha de fin",
      fecha_alta: "Fecha Alta",
      duracion_meses: "Duración (en meses)",
      dedicacion: "Dedicación (% jornada)",
      departamento: "Departamento",
      modalidad: "Modalidad",
      numero_dias_semana: "Numero de días por semana",
      dias_semana: "Días de la semana",
      vinculado_tfg: "Vinculado a TFG",
      nombre_tfg: "Nombre TFG",
      tutor_tfg: "Tutor/a TFG",
      solicitante: "Solicitante del servicio",
      centro_practicas: "Centro de prácticas",
      n_pedido: "Nº de pedido (si lo requiere)",
      observaciones: "Observaciones",
      direccion: "Dirección",
      nombre_tutor_uni:
        "Nombre y apellidos del tutoro tutora de la Universidad",
      datos_tutor_empresa: "Datos del tutor o tutora en la empresa",
      nombre: "Nombre",
      apellidos: "Apellidos",
      email: "Email",
      telefono: "Teléfono",
      cargo: "Cargo",
      dni: "DNI",
      titulacion_especialidad: "Titulación o especialidad",
      titulacion: "Titulación/ Cargo",
      selecciona: "-Seleccionar-",
      nombre_oferta: "Nombre de la oferta",
      numero_plazas: "Número de plazas",
      experiencia_requerida: "Experiencia requerida",
      experiencia_deseable: "Experiencia deseable",
      opciones_publicacion: "Opciones de publicación",
      url_inscripcion: "URL inscripción empresa",
      candidato_preferido: "Candidato/a preferido",
      datos_realizacion: "Datos de realización de la práctica",
      conocimientos_especificos: "Conocimientos especificos",
      formacion_adquirida: "Formación adquirida",
      seguimiento_previsto: "Seguimiento previsto",
      empresa_destino:
        "Empresa destinataria (solamente si es oferta de una gestora/consultora ETT)",
      datos_tutor: "Datos del tutor/a de la empresa",
      para_estudiantes_ultimo_ano: "Para estudiantes de último año",
      curso_minimo_requerido: "Curso mínimo requerido",
      para_perfil_no_universitario: "Para perfil no universitario",
      activo_quest: "¿Activo?",
      ano_promo_maximo: "Año de promoción máximo",
      enviar_quest: "¿Enviar?",
      candidato_leer: "Candidato/a por leer",
      candidatos_leer: "Candidatos/as por leer",
      candidato_total: "Candidato/a en total",
      referencia: "Referència",
      candidatos_total: "Candidatos/as en total",
      ver_detalles: "Ver detalles",
      con_practicas: "Con prácticas asignadas",
      fecha_caducidad: "Fecha de caducidad",
      buscar_mas_programa: "Busca más programas informáticos",
      programas_elegidos: "Programas informáticos elegidos",
      sin_programas: "Sin programas informáticos especificados",
      selecciona_idioma: "Selecciona un idioma",
      escribe_idioma: "Escribe aquí el idioma",
      indica_certificacion:
        "Indica aquí la certificación o nivel mínimo requerido",
      titulaciones: "Titulaciones",
      requeridas: "requeridas",
      deseables: "valorables",
      propuestas: "propuestas",
      a_las_que: "a las que se dirige la oferta",
      nivel: "Nivel",
      areas: "Áreas",
      cualquier_area: "Cualquier área",
      ninguna_titulacion:
        "Ninguna titulación concuerda con el filtro de nivel indicado.",
      eliminar_todas: "Eliminar todas",
      areas_dirige: "Áreas a las que se dirige la oferta",
      titulaciones_dirige: "Titulaciones a las que se dirige la oferta",
      selecciona_titulaciones:
        "Selecciona las titulaciones en el listado de la izquierda",
      cumplimentar:
        "Cumplimentar solo en el caso de que considere que es información relevante para los candidatos/as.",
      tipo_estudios: "Tipo de estudios",
      seleccione_izquierda:
        "Selecciona las áreas en el listado de la izquierda.",
      seleccione_algun_nivel:
        "Seleccione algún nivel para cargar las áreas asociadas",
      especialidad_titulacion: "Especialidad o titulación",
      puesto_trabajo: "Puesto de trabajo",
      motivo_rechazo: "Motivo de rechazo",
      ayuda_estudio: "Ayuda al estudio",
      tutor_empresa: "Tutor/a de la empresa",
      nombre_tutor: "Nombre del tutor o tutora de empresa",
      apellidos_tutor: "Apellidos del tutor o tutora de empresa",
      email_tutor: "Email del tutor o tutora de empresa",
      telefono_tutor: "Teléfono del tutor o tutora de empresa",
      cargo_tutor: "Cargo del tutor o tutora empresa",
      titulacion_tutor: "Titulación del tutor o tutora de empresa",
      departamento_tutor: "Departamento del tutor o tutora de empresa",
      dni_tutor: "DNI del tutor o tutora de empresa",
      no_definido: "No definido",
      candidatos: "Candidatos/as",
      exportar: "Exportar",
      no_hay_candidatos: "No hay candidatos/as en esta oferta",
      mas: "más",
      menos: "menos",
      empresa_destino_simple: "Empresa de destino",
      tipo_formacion: "Tipo de formación",
      niveles: "Niveles",
      areas: "Áreas",
      para_estudiantes_ultimo_curso: "Para estudiantes de último curso",
      duplicar_oferta_aviso:
        "Oferta duplicada correctamente ¿Quieres editarla ahora?",
      alumno_validado_uib: "Estudiante validado por EUNCET",
      condicionespracticas:
        "He leído y estoy de acuerdo con las condiciones. <a>Ver condiciones</a>",
      idioma: "Idioma",
      ofertacerrada:
        "Una oferta cerrada no estará visible ni recibirá nuevos candidatos. ¿Estás seguro de querer cerrar esta oferta?",
      eliminaroferta: "Se va a eliminar la oferta ¿Quieres continuar?",
      ofertaduplicada:
        "Oferta duplicada correctamente ¿Quieres editarla ahora?",
      controlCerraroferta:
        "¿Ha seleccionado a alguno de los candidatos propuestos por EUNCET?",
      cumplimentainformacion: "Por favor cumplimente la siguiente información",
      nombrepersona: "Nombre y apellidos de la persona seleccionada",
      fechainiciocontrato: "Fecha de inicio del contrato",
      tipocontrato: "Tipo de contrato",
      nota_media: "Nota media",
      observaciones: "Observaciones",
      nombre_apellidos_dni: "Nombre, apellidos y DNI",
      ocultar_datos_empresa: "Ocultar datos de la empresa",
      url_informacion_complementaria: "URL para información complementaria",
      fichero_informacion_complementaria: "Fichero información complementaria",
      ver_fichero_adjunto: "Ver fichero adjunto",
      datos_firmante: "Datos de la persona firmante",
      firmante: {
        nombre: "Nombre de la persona firmante",
        apellidos: "Apellidos de la persona firmante",
        email: "Email de la pesona firmante",
        dni: "DNI de la persona firmante",
        cargo: "Cargo de la persona firmante",
        telefono: "Teléfono",
      },
      num_Pedido: "Número de pedido",
    },
    filtro_oferta: {
      buscar_nombre: "Busca por nombre del puesto",
      buscar_localizacion: "Busca por localización",
      buscar_titulacion: "Busca por titulación",
      buscar_puesto: "Busca por nombre del puesto",
      filtro_avanzado: "Filtro Avanzado",
      cerrar: "Cerrar",
      fecha_publicacion: "Fecha publicación",
      fecha_inicio_previsa: "Fecha prevista de inicio de la práctica",
      fecha_inicio: "Fecha de inicio",
      filtrado_etiqueta: "Filtrado por etiquetas",
      omitir_inscritos: "Omitir ya inscritos",
      oferta_tfg: "Oferta TFG/TFM",
      ofertas_internacional: "Oferta internacional",
      ofertas_cv: "Ofertas que encajan con mi perfil/cv",
      busquedas_guardadas: "Búsquedas guardadas",
      guardar_busqueda: "Guardar búsqueda",
      borrar_filtros: "BORRAR FILTROS",
      ver: "Ver",
      fecha: "Fecha",
      ofertas_tfg: "Oferta TFG/TFM",
      se_han_encontrado: "Se han encontrado",
      introduce_nombre_busqueda: "Introduce el nombre de la búsqueda",
      sobreescribe_existente: "ó sobreescribe una existente",
      selecciona_busqueda: "Selecciona una búsqueda",
      ver_historico: "Ver histórico de ofertas",
      ver_actuales: "Ver ofertas actuales",
      crear_oferta: "CREAR OFERTA",
      historico_ofertas: "Histórico de ofertas",
      no_hay_ofertas: "No hay ofertas coincidentes con tu búsqueda",
      solo_con_candidatos: "Sólo ofertas con candidatos/as sin leer",
      tienen_candidatos: "Tienen candidatos/as",
      caduca_pronto: "Caducan pronto",
      no_leidos: "Solo no leidos",
      modalidad: "Modalidad",
      puesto_Empresa: "Puesto/ Empresa",
      buscar_sector: "Buscar por sector",
    },
    popup_confirmacion: {
      recuerda: "¡Recuerda!",
      titulo:
        "Asegúrate de que los datos de tu perfil están actualizados antes de inscribirte a una oferta.",
      actualiza: "Actualízalo pinchando",
      aqui: "aquí.",
      confirma_titulo:
        "Por favor confirma que quieres ser candidato/a en esta oferta.",
      atencion: "¡Atención!",
      necesitamos_anadir:
        "Necesitamos que añadas los siguientes documentos para poder inscribirte a la oferta.",
      url_documento: "URL del documento",
      por_favor_adjunta: "Por favor, adjunta un archivo o url",
      alumnos_master:
        "Los estudiantes de máster de 2 años de duración deben tener al menos el 50% de los créditos aprobados, a fecha de inicio de realización de las prácticas, para poder realizarlas. ¿Eres estudiante de máster de duración inferior a 2 años, o has superado el 50% de los créditos?",
      inscripcion_externa:
        "La inscripción de esta oferta se realiza a través de la web de la empresa.",
      confirma_inscripcion_externa:
        "Por favor, confirma que quieres ser redirigido a la web de la empresa para inscribirte a la oferta.",
    },
    header: {
      hola: "Hola,",
      oferta_practicas: "Buscar ofertas de prácticas",
      oferta_empleo: "Buscar ofertas de empleo",
      propuesta_practicas: "Propuesta de prácticas",
      candidaturas: "Mis candidaturas",
      practicas: "Mis prácticas",
      programas: "Programas",
      encuestas: "Encuestas",
      eventos: "Eventos",
      mi_cv: "Mi CV",
      guias_orientacion: "Guías Orientación",
      mis_ofertas: "Mis ofertas",
      nueva_oferta: "Nueva oferta",
      solicitar_cambio_practicas: "Solicitar cambio de prácticas",
      documentacion: "Documentación",
      solicitudes_practicas_educacion: "Solicitudes prácticas educación",
      encuestas: "Encuestas",
      mi_empresa: "Mi empresa",
      ayuda: "Ayuda",
      cerrar_sesion: "Cerrar sesión",
      solicitar_baja: "Solicitar baja",
      formulario_datos: "Formulario datos",
    },
    image_uploader: {
      titulo: "Editar imagen de perfil",
    },
    notificaciones: {
      borrar_todo: "Borrar todo",
      importantes: "Importantes",
      otras_notificaciones: "Otras notificaciones",
      no_notificaciones: "No tienes notificaciones pendientes",
    },
    popup_borrar_cuenta: {
      titulo:
        "¿Desea solicitar la baja del servicio y la supresión de sus datos personales?",
      si: "Sí",
      no: "No",
    },
    popup_faltan_datos_empresa: {
      atencion: "¡Atención!",
      cuerpo_1:
        "Faltan datos obligatorios en tu perfil, por favor accede para completarlos.",
      cuerpo_2:
        "Faltan datos obligatorios en el perfil de tu empresa, por favor accede para completarlos.",
      ir_a_perfil: "Ir a mi Perfil",
      ir_a_empresa: "Ir a Mi empresa",
    },
    popup_datos_personales: {
      atencion: "¡Atención!",
      titulo:
        "Faltan datos obligatorios en tu perfil, por favor accede para completarlos.",
      ir_a_perfil: "Ir a mi Perfil",
    },
    solicitudes_educacion: {
      titulo:
        "En esta sección encontrarás la información de los estudiantes que han solicitado la realización de prácticas en su centro.",
      zero: "No hay documentación en estos momentos.",
    },
    filtro_candidaturas: {
      buscar_nombre: "Busca por nombre del puesto",
      empleo: "Empleo",
      practicas: "Prácticas",
      filtro_avanzado: "Filtro Avanzado",
      cerrar: "Cerrar",
      estado: "Estado",
      ver: "Ver",
      borrar_filtros: "BORRAR FILTROS",
      estas_en: "Estas en",
      zero: "No hay procesos de selección coincidentes con tu búsqueda",
    },
    documentacion: {
      intro:
        "En esta sección encontrarás la documentación relacionada con las prácticas que se han realizado en tu empresa.",
      convenio_titulo: "Convenios de colaboración",
      caducado: "(Caducado) -",
      zero_convenio: "Aún no tienes ningún convenio",
      titulo_convenio:
        "Si lo deseas puedes solicitar y descargar el convenio de colaboración, o aportar el documento ya firmado por tu empresa",
      nuevo_convenio: "Nuevo convenio",
      subir_convenio: "Subir convenio firmado",
      anexos_practicas: "Anexos de prácticas",
      zero_practicas: "Aún no tienes contenido",
      notas_formativas: "Notas formativas",
      en: "en",
      otros_documentos: "Otros documentos asociados ",
      zero_documentos: "Aún no tienes ningún documento asociado",
      otros_documentos_programas: "Otros documentos de programas",
      zero_documentos_practicas:
        "Aún no tienes ningún documento asociado a prácticas",
      documentos_aportados_empresa: "Otros documentos aportados por la empresa",
      no_documentos_anadidos:
        "No hay documentos añadidos, pulsa para añadir uno",
      anadir_documentacion: "Añadir documentación",
      selecciona_documento: "Selecciona un documento",
      listado_documento: "Listado de documentos",
      otro_tipo_documento: "Otro tipo de documento",
      nombre_documento: "Nombre del documento",
      url_documento: "URL del documento",
    },
    encuestas: {
      titulo: "Encuestas",
      obligatorias: "Para continuar, responde todas las preguntas obligatorias",
      enviar: "Enviar",
      siguiente: "Siguiente",
      empezar_de_nuevo: "Empezar de nuevo",
      pagina: "Página",
      datos_enviados: "Tus datos han sido enviados",
      muchas_gracias: "¡Muchas gracias!",
      iniciar_sesion: "Inicia sesión con tu usuario de perfil",
      empresa: "Empresa",
      candidato: "Candidato",
      usuario: "Usuario",
      contrasena: "Contraseña",
      acceder: "Acceder",
      o: "ó",
      acceder_anonimamente: "Acceder de forma anonima",
      contestar_pregunta: "Debes contestar a esta pregunta para continuar",
      zero: "No hay encuestas disponibles",
      titulo: "Encuestas Pendientes",
      cuerpo: "Por favor, antes de continuar, responda estas encuestas",
      no_puedes:
        "No puedes acceder al portal hasta que no hayas contestado las encuestas pendientes. Si no deseas responder en este momento, puedes cerrar tu sesión.",
    },
    eventos: {
      proximos: "Próximos eventos",
      pasados: "Eventos pasados",
      evento_destacado: "Evento destacado",
      desde: "Desde",
      hasta: "Hasta",
      organizado_por: "Organizado por",
      inscribirse: "Inscribirse",
      inscrito: "Inscrito",
      mas_informacion: "Más información",
      galeria: "Galería de imágenes",
      videos: "Vídeos",
      buscar_localizacion: "Buscar por localización",
      buscar_categoria: "Buscar por categoría",
      buscar_nombre: "Buscar por nombre",
      eventos_pasados: "Eventos ya pasados",
      ver_mas: "Ver más",
    },
    comunicaciones: {
      titulo: "Comunicaciones",
    },
    guias: {
      titulo: "Últimas guías de orientación",
      zero: "No hay guias de orientación",
    },
    ofertas: {
      ultimas_practicas: "Últimas ofertas de prácticas",
      practicas: "Prácticas",
      ultimas_empleo: "Últimas ofertas de empleo",
      empleo: "Empleo",
      ofertas: "Ofertas",
      zero_ofertas: "No hay ofertas disponibles.",
      contrato: "Contrato",
      idContrato: "Contrato",
      salario: "Salario",
      areaFuncional: "Área Funcional",
      provincia: "Provincia",
      areasTitulaciones: "Áreas de titulaciones",
      nivelesTitulaciones: "Niveles de titulaciones",
      tiposFormacion: "Tipos de formación",
      tituloPrograma: "Programa",
      area: "Área",
      filtrar_titulacion: "Filtrar por titulación",
      tipoModalidadAsistencia: "Modalidad de asistencia",
    },
    cv: {
      nivel: "Nivel",
      programa_informatico: "Programa informático",
      certificado: "Certificado",
      sin_nivel: "Sin nivel definido",
      presentacion: "Presentación",
      anadir_presentacion: "Para añadir tu presenctación pulsa",
      aqui: "aquí",
      otros_intereses: "Otros intereses",
      tus_interes: "Tus intereses",
      sin_intereses: "Sin intereses especificados",
      escribe_interes: "Escribe algún interes, para comenzar a buscar",
      click_interes: "Haz click sobre el interes, para añadirlo",
      click_cambiar_imagen: "Haz click para cambiar la imagen",
      cambiar_contrasena: "Cambiar contraseña",
      idiomas: "Idiomas",
      idioma: "Idioma",
      sin_idiomas: "Sin idiomas añadidos, pulsa en añadir idioma para añadirlo",
      idioma_obligatorio:
        "El idioma y el nivel son campos obligatorios para añadir un idioma",
      nivel_no_definido: "Nivel no definido",
      nivel: "Nivel",
      nombre_certificado: "Nombre del certificado",
      estancia_extranjero: "Estancia en el extranjero",
      pais_estancia: "País de estancia",
      motivo_estancia: "Motivo de la estancia",
      duracion_meses: "Duración en meses",
      experiencia_profesional: "Experiencia profesional",
      anadir_nueva_experiencia: "Añadir nueva experiencia",
      sin_experiencia: "Sin experiencia",
      nivel_formativo: "Nivel formativo",
      actualidad: "Actualidad",
      puesto: "Titulo del puesto",
      anadir_documento: "Añadir documento",
      sector_empresa: "Sector de la empresa",
      area_actividad_puesto: "Área de actividad del puesto",
      tipo_contrato: "Tipo de contrato",
      subtipo_contrato: "Subtipo de contrato",
      ver_adjunto: "Ver adjunto",
      ver_enlace: "Ver enlace",
      duracion: "Duración",
      fecha_inicio: "Fecha de inicio",
      fecha_fin: "Fecha de fin",
      provincia: "Provincia",
      empresa: "Empresa",
      enlace: "Enlace",
      descripcion_puesto: "Descripción del puesto",
      escribe_descripcion: "Escribe una descripción de las tareas desempeñadas",
      anadir_fichero: "Adjuntar fichero",
      adjunto_correctamente: "Archivo adjunto correctamente",
      isla: "Isla",
      programas_informaticos: {
        titulo: "Programas informáticos",
        buscar: "Escribe para buscar",
        zero: "No hay programas informáticos añadidos, pulsa en añadir para añadirlos",
        anadir: "Añadir Programa",
      },
      sectores_interes: {
        titulo: "Sectores de interés",
        buscar: "Escribe para buscar",
        zero: "No hay sectores de interés añadidos, pulsa en añadir para añadirlos",
        anadir: "Añadir sector de interés",
      },
      documentacion_adjunta: "Documentación adjunta",
      documentacion_subida: "Documentación subida el",
      no_hay_documentos: "No hay documentos añadidos",
      pulsa_anadir_documentos: "pulsa en añadir documento para añadirlo",
      anadir_documentacion: "Añadir documentación",
      selecciona_documento: "Selecciona un documento",
      listado_documento: "Listado de documentos",
      otro_tipo_documento: "Otro tipo de documento",
      nombre_documento: "Nombre del documento",
      url_documento: "URL del documento",
      documentacion_privada: "Documentación privada",
      no_documentos:
        "No hay documentos añadidos, pulsa en añadir documento para añadirlo",
      documentacion_ligada: "Documentación ligada a procesos",
      datos_profesionales: "Datos profesionales",
      visitar: "Visitar",
      indica_link_perfil: "Indica link a tu perfil",
      trabajando_actualmente: "Trabajando actualmente",
      permiso_trabajo: "Permiso de trabajo en la UE",
      anos_experiencia: "Años de experiencia",
      sin_experiencia: "Sin experiencia",
      disfrutado_erasmus:
        "He estado de Erasmus o he disfrutado de otra beca de movilidad",
      minima_retribucion: "Mínima retribución",
      brutos_anuales: "/ brutos anuales",
      datos_personales: "Datos personales",
      dni: "DNI",
      fecha_nacimiento: "Fecha de nacimiento",
      genero: "Género",
      femenino: "Femenino",
      masculino: "Masculino",
      email_personal: "Email personal",
      email_estudiante: "Email de estudiante",
      avisos_en_email: "Avisos en el email personal",
      acepta_newsletter: "Acepta newsletter",
      idioma_comunicaciones: "Idioma preferido para las comunicaciones",
      movil: "Movil",
      fijo: "Teléfono fijo",
      direccion_empadronamiento: "Dirección de empadronamiento",
      direccion_actual: "Dirección actual",
      direccion: "Dirección",
      iban: "Nº cuenta IBAN",
      seguridad_social: "Nº de afiliación a la Seguridad social",
      pais_nacionalidad: "País de nacionalidad",
      pais_segunda_nacionalidad: "País de segunda nacionalidad",
      provincia_nacimiento: "Provincia de nacimiento",
      provincia: "Provincia",
      lugar_nacimiento: "Lugar de nacimiento",
      discapacidad: "Discapacidad superior al 33%",
      deseo_recibir_comunicaciones:
        "Deseo recibir comunicaciones relacionadas con EUNCET y con servicios relacionados con formación superior.",
      nombre: "Nombre",
      primer_apellido: "Primer apellido",
      segundo_apellido: "Segundo apellido",
      tipo_identificacion: "Tipo de identificación",
      documento_identidad: "Titulo del puesto",
      buscar: "Añadir documento",
      cp: "Código postal",
      pais: "País",
      localidad: "Localidad",
      tipo_via: "Tipo de vía",
      numero: "Número",
      piso: "Piso",
      puerta: "Puerta",
      notas: "Notas",
      datos_academicos: "Datos académicos",
      formacion_complementaria: "Formación complementaria",
      anadir_titulacion: "Añadir nueva titulación",
      complementaria: "complementaria",
      centro: "Centro",
      nivel_academico: "Nivel académico",
      tipo: "Tipo",
      nota: "Nota",
      rama_ensenanza: "Rama de la enseñanza",
      duracion: "Duración",
      actual: "Actual",
      si: "Sí",
      no: "No",
      titulo: "Titulo",
      universidad: "Universidad/Lugar de estudios",
      centro_estudios: "Centro en el que cursaste los estudios",
      calificacion: "Calificación",
      calificacion_media: "Calificación media del titulo",
      horas: "Horas",
      ambito: "Ambito de la enseñanza",
      selecciona_tipo: "- Selecciona un tipo -",
      certificacion: "Certificación",
      tienes_cerfificacion: "¿Tienes certificación?",
      competencias_profesionales: "Competencias profesionales",
      tus_competencias: "Tus competencias",
      sin_competencias: "Sin competencias profesionales especificadas",
      solicitar_sesion:
        "¿Necesitas ayuda para cumplimentar este apartado? Puedes solicitar una sesión gratuita de orientación con nosotros pinchando en este <a>enlace</a> y te ayudaremos.",
      datos_interes: "Datos de interés",
      busqueda_activa_practicas: "Búsqueda activa de prácticas",
      busqueda_activa_empleo: "Búsqueda activa de empleo",
      disponible_extranjero: "Disponibilidad para trabajar en el extranjero",
      permiso_conducir: "Permiso de conducir",
      disponible_cambio_residencia: "Disponible para cambio de residencia",
      coche_propio: "Coche propio",
      disponible_viajar: "Disponibilidad para viajar",
      discapacidad_certificada: "Discapacidad certificada",
      carnet_moto: "Carnet de moto",
      moto_propia: "Moto propia",
      disponibilidad_jornadas: "Disponibilidad de jornadas",
      periodo_preferencia_practicas: "Periodo preferencia de prácticas",
      selecciona: "Selecciona",
      anadir_idioma: "Añadir idioma",
      anadir_intereses: "Añadir intereses",
      nuevos_datos_academicos: "Nuevos datos académicos",
    },
    addtitulacion: {
      titulo: "Titulaciones a las que se dirige la oferta",
      seleccione_areas: "Seleccione área/s para filtrar titulaciones",
      borrar_areas: "Borrar todas las áreas",
      cualquier_area: "Cualquier área",
      escriba_aqui:
        "Escriba aquí para filtrar el listado de titulaciones a continuación",
      selecciona_titulacion:
        "Seleccione titulación/es a la/s que se dirige la oferta haciendo clic sobre ella/s",
      ver_titulaciones: "Ver titulaciones de grado",
      listadas: "listadas",
      listados: "listados",
      cualquier_titulacion: "Cualquiera de estas titulaciones de grado",
      ver_titulaciones_postgrado: "Ver titulaciones de postgrado",
      cualquier_titulacion_postgrado:
        "Cualquiera de estas titulaciones de postgrado",
      ver_titulaciones_propio: "Ver titulaciones de Título propio",
      cualquier_titulacion_propio: "Cualquiera de estos títulos propios",
      lo_sentimos:
        "Lo sentimos no se han encontrado titulaciones que coincidan con la búsqueda",
      listado_titulaciones_seleccionadas:
        "Listado de titulaciones seleccionadas",
      eliminar_titulaciones: "Eliminar todas las titulaciones seleccionadas",
    },
    candidato: {
      nuevo: "Nuevo",
      pendiente_form_incorporacion: "Pendiente formulario incorporación​",
      cambiar_estado: "Cambiar estado",
      ver_cv: "Ver CV",
      detalles: "Detalles del candidato/a",
      selecciona_estado: "Selecciona un estado",
      seleccione_motivo:
        "Por favor seleccione el motivo de rechazo del candidato/a.",
      cambio_estado: "Cambio de estado",
      descargar_cv: "Descargar CV",
      cumplimentar_formulario_incorporacion:
        "Cumplimentar formulario de incorporación",
    },
    cambio_practicas: {
      identifica:
        "Identifica el estudiante del que solicitan realizar prórroga o variación de sus condiciones de prácticas.",
      alumno: "Estudiante",
      selecciona_oferta: "Selecciona la oferta",
      no_practicas:
        "Aún no tienes ninguna práctica sobre la que puedas solicitar un cambio.",
      alumno: "Estudiante",
      selecciona_alumno: "Selecciona el estudiante",
      detalles: "Detalles de la modificación",
      tipo_modificacion: "Tipo de modificación",
      selecciona_modificacion: "-Selecciona la modificación-",
      otros_detalles: "Otros detalles",
      adjunto: "Adjunto",
      solicitar_cambio: "Solicitar cambio",
    },
    popup_idioma: {
      titulo: "Vas a cambiar tu preferencia de idioma. ¿Quieres continuar?",
    },
    formulario_incorporacion: {
      formularioYaCumplimentado:
        "Este formulario de incorporación ya ha sido cumplimentado. Este proceso requiere la validación por parte de un gestor de EUNCET​.",
      encabezado:
        "Rellena el formulario de incorporación para completar la candidatura del estudiante y pasarla a la persona seleccionada.",
      persona_de_contacto: "Persona de contacto",
      contacto_nombre: "Nombre",
      contacto_apellidos: "Apellidos",
      contacto_cargo_departamento: "Cargo/Departamento",
      contacto_email: "E-mail",
      contacto_num_telefono: "Nº de Teléfono",
      persona_firmante_anexo_convenio: "Persona firmante del anexo",
      persona_firmante_convenio_empresa:
        "Persona firmante del convenio de cooperació educativa",
      firmante_nombre: "Nombre",
      firmante_apellidos: "Apellidos",
      firmante_cargo_departamento: "Cargo del firmante",
      firmante_email: "E-mail",
      firmante_telefono: "Teléfono",
      datos_alumno: "Datos del estudiante",
      alumno_dni: "DNI",
      alumno_nombre_apellidos: "Nombre y apellidos",
      alumno_titulacion: "Titulación",
      fecha_inicio: "Fecha de inicio",
      fecha_fin: "Fecha de fin",
      datos_periodo_practicas: "Datos sobre el periodo de prácticas",
      lugar_realizacion_practicas: "Lugar de realización de las prácticas",
      datos_tutor_empresa: "Datos del tutor o tutora en la empresa",
      tutor_nombre: "Nombre",
      tutor_apellidos: "Apellidos",
      tutor_cargo: "Cargo en Empresa",
      tutor_email: "E-mail",
      tutor_dni: "DNI",
      tutor_telefono: "Teléfono",
      horario: "Horario",
      num_horas_dia: "Número de horas al día",
      num_horas_semana: "Número de horas por semana",
      horas_semana: "Horas semanales",
      retribucion_euros_hora: "Retribución € brutos/hora",
      otras_remuneraciones: "Otras remuneraciones",
      descripcion_actividad:
        "Descripción detallada de la actividad a realizar por el estudiante (imprescindible para valorar y aprobar su idoneidad)",
      datos_facturacion: "Datos de facturación",
      info_datos_facturacion:
        "Si es necesario número de pedido o número de orden de compra para la gestión de la factura en concepto de “gastos de gestión del convenio” de 90€+IVA que emitirá Euncet, por favor, indique a continuación el número​",
      num_pedido: "Número de pedido",
      comp_genericas:
        "Competencias genéricas que el/la estudiante trabajará durante las prácticas",
      compEspecificas: "Competencias específicas",
      formaPrevistaSeguimientoOrientacion:
        "Forma prevista de Seguimiento y Orientación",
      seguimientoDiario: "Seguimiento diario",
      reunionesSemanales: "Reuniones semanales",
      reunionesPeriodicas: "Reuniones periódicas",
      seguridadSalud:
        "Seguridad y salud durante la realización de las prácticas",
      seguridadSalud_informado:
        "Se le ha informado sobre los aspectos de seguridad y salud que tendrá que seguir en la empresa durante la realización de las prácticas (entrega del documento de identificación de riesgos y medidas preventivas de su puesto)",
      seguridadSalud_entregado:
        "Se le han entregado los equipos de protección individual (sólo en caso de ser necesarios)",
      otros: "Otros (Especificar)",
      formacionAdquirida: "Formación que adquirirá el estudiante",
      actividadesTareas: "Actividades y tareas que tiene que desarrollar el estudiante",
      lenguaInglesa: "Lengua Inglesa",
      lenguaInglesa_texto: "Comunicarse en inglés con un nivel adecuado de expresión oral y escrita de acuerdo con el ámbito de intervención profesional",
      comunicacion: "Comunicación", 
      comunicacion_texto: "Comunicarse oralmente y por escrito con destreza y fluidez en la lengua del entorno profesional",
      trabajoEquipo: "Trabajo en equipo",
      trabajoEquipo_texto: "Trabajar en equipo a diferentes niveles y con diferentes profesionales e instituciones relacionadas con el contexto empresarial",
      direccionPersonas: "Dirección de personas",
      direccionPersonas_texto: "Dirigir personas y equipos profesionales",
      investigacion: "Investigación y gestión de la información", 
      investigacion_texto: "Buscar y gestionar información empresarial y valorar de forma crítica los resultados obtenidos",
      aprendizajeAutonomo: "Aprendizaje autónomo",
      aprendizajeAutonomo_texto: "Aprender de forma autónoma",
      autoconocimiento: "Autoconocimiento",
      autoconocimiento_texto: "Detectar limitaciones y carencias en los propios conocimientos y competencias profesionales y ser capaz de superarlas",
      planificacion: "Planificación y organización",
      planificacion_texto: "Planificar y organizar tareas para alcanzar los objetivos en los plazos establecidos",
      orientacion: "Orientación al logro",
      orientacion_texto: "Identificar problemas, obstáculos y oportunidades y saber proponer mejoras y encontrar nuevas estrategias o soluciones",
      empatia: "Empatía y habilidades sociales",
      empatia_texto: "Percibir y comprender las situaciones sociales de las personas que le rodean",
      flexibilidad: "Flexibilidad",
      flexibilidad_texto: "Adaptarse a situaciones y personas en contextos de aprendizaje y profesionales",
      pensamientoAnalitico: "Pensamiento analítico",
      pensamientoAnalitico_texto: "Identificar y valorar las situaciones y problemas, separando y organizando sus partes integrantes, y reflexionar sobre ellas de una forma lógica y sistemática"
    },
    popup_aceptaSS: {
      info: "Información sobre la Seguridad Social",
      remunerada:
        "A partir del 1 de enero de 2024, tal y como establece el Real Decreto-Ley 2/2023 (artículo único ap.34), quedarán <strong>incluidos en el sistema de Seguridad Social</strong> todos los estudiantes que realicen prácticas académicas externas, <strong>tanto prácticas remuneradas como prácticas no remuneradas.</strong>​</br></br>El cumplimiento de las obligaciones de Seguridad Social corresponderá siempre a la empresa, institución o entidad en la que se desarrollan las prácticas, que asumirá a estos efectos la condición de empresario; excepto casos excepcionales en los que se haya acordado previamente que se hará cargo Euncet y que se haya indicado expresamente y firmado en el convenio de cooperación educativa.",
      no_remunerada:
        "A partir del 1 de enero de 2024, tal y como establece el Real Decreto-Ley 2/2023 (artículo único ap.34), quedarán <strong>incluidos en el sistema de Seguridad Social</strong> todos los estudiantes que realicen prácticas académicas externas, <strong>tanto prácticas remuneradas como prácticas no remuneradas.</strong>​</br></br>El cumplimiento de las obligaciones de Seguridad Social corresponderá siempre a la empresa, institución o entidad en la que se desarrollan las prácticas, que asumirá a estos efectos la condición de empresario; excepto casos excepcionales en los que se haya acordado previamente que se hará cargo Euncet y que se haya indicado expresamente y firmado en el convenio de cooperación educativa.",
      entendido: "He leído y entiendo las obligaciones de Seguridad Social",
      aceptar: "Aceptar",
    },
    politica_privacidad: {
      informacion_usuario: "1. INFORMACIÓN AL USUARIO",
      responsable_tratamiento:
        "¿Quién es el responsable del tratamiento de tus datos personales?",
      responsable_tratamiento_text:
        "<b>EUNCET FORMACIÓN SL</b> es el RESPONSABLE del tratamiento de los datos personales del USUARIO y le informa de que estos datos serán tratados de conformidad con lo dispuesto en el Reglamento (UE) 2016/679, de 27 de abril (RGPD), y la Ley Orgánica 3/2018, de 5 de diciembre (LOPDGDD).",
      para_que_tratamos: "¿Para qué tratamos tus datos personales?",
      para_que_tratamos_text1:
        "Los datos personales recogidos serán tratados por el RESPONSABLE para las siguientes finalidades",
      para_que_tratamos_text2:
        "Remisión de comunicaciones comerciales publicitarias por e-mail, fax, SMS, MMS, redes sociales o cualquier otro medio electrónico o físico, presente o futuro, que posibilite realizar comunicaciones comerciales. Estas comunicaciones serán realizadas por el RESPONSABLE y estarán relacionadas con sus productos y servicios, o de sus colaboradores o proveedores, con los que este haya alcanzado algún acuerdo de promoción. En este caso, los terceros nunca tendrán acceso a los datos personales.",
      para_que_tratamos_text3:
        "Realizar estudios de mercado y análisis estadísticos.",
      para_que_tratamos_text4:
        "Tramitar encargos, solicitudes, dar respuesta a las consultas o cualquier tipo de petición que sea realizada por el USUARIO a través de cualquiera de las formas de contacto que se ponen a su disposición en la página web del RESPONSABLE",
      para_que_tratamos_text5:
        "Remitir el boletín informativo online sobre novedades, ofertas y promociones RESPONSABLE.",
      para_que_tratamos_text6:
        "Tratamientos derivados de la actividad docente.",
      para_que_tratamos_text7:
        "Envío, recepción de CV y cumplimentación de formularios gestión de procesos de selección de personal que se encuentren habilitados o puedan habilitarse por parte del RESPONSABLE o por terceros a través de la plataforma establecida a tal fin.",
      para_que_tratamos_text8:
        "Gestión de Canal de Denuncias. El RESPONSABLE dispone de un canal de denuncias que asegura el derecho de las personas a informar de incidentes, mala conducta y otros comportamientos sustancialmente incorrectos. Tal y como prevé la normativa vigente, estas denuncias pueden ser anónimas. En caso de que la persona denunciante se identifique, trataremos sus datos con el único fin de tramitar la denuncia y elaborar el informe correspondiente. En ningún caso se hará uso de estos datos para fines distintos a la gestión de la denuncia y se conservarán solo el tiempo necesario para llevar a cabo la finalidad o hasta que exista la obligación legal de conservarlas.",
      para_que_tratamos_text9:
        "Mantener una relación entre los usuarios y el RESPONSABLE a través de sus redes sociales que puede incluir las siguientes operaciones",
      para_que_tratamos_text10: "Tramitar solicitudes y consultas.",
      para_que_tratamos_text11:
        "Informar sobre actividades y eventos organizados por el responsable.",
      para_que_tratamos_text12:
        "Informar sobre productos o servicios ofrecidos por el RESPONSABLE.",
      para_que_tratamos_text13:
        "Interactuar a través de los perfiles oficiales.",
      por_que_tratamos: "¿Por qué motivo podemos tratar tus datos personales?",
      por_que_tratamos_text1:
        "Porque el tratamiento está legitimado por el artículo 6 del RGPD de la siguiente forma",
      por_que_tratamos_text2: "Con el consentimiento del USUARIO",
      por_que_tratamos_text3:
        "Remisión de comunicaciones comerciales y del boletín informativo.",
      por_que_tratamos_text4:
        "Gestión de los procesos de selección de personal.",
      por_que_tratamos_text5:
        "Mantener una relación con el RESPOSABLE a través de sus redes sociales. Si el usuario dispone de un perfil en la misma red social y ha decidido unirse a la red social del RESPOSABLE, ha mostrado un interés en la información que se publique y, por tanto, a la hora de solicitar seguir nuestros perfiles oficiales, nos facilita el consentimiento para el tratamiento de los datos personales publicados en su perfil.",
      por_que_tratamos_text6:
        "Puede acceder en cualquier momento a las políticas de privacidad de la propia red social, y configurar su perfil para garantizar su privacidad. El RESPONSABLE tiene acceso y trata la información suya pública, especialmente, su nombre de contacto.",
      por_que_tratamos_text7:
        "Por interés legítimo del RESPONSABLE realizar estudios de mercado, análisis estadísticos, tratamientos derivados de la actividad docente y tramitar encargos, solicitudes, etc. a petición del USUARIO.",
      por_que_tratamos_text8:
        "Por obligación legal gestión del canal de denuncias.",
      por_que_tratamos_text9:
        "Por ser necesario en la ejecución de un contrato prestación de servicios y los tratamientos derivados de la actividad docente.",
      durante_cuanto_tiempo_tratamos:
        "¿Durante cuánto tiempo guardaremos tus datos personales?",
      durante_cuanto_tiempo_tratamos_text1:
        "Se conservarán durante no más tiempo del necesario para mantener el fin del tratamiento o existan prescripciones legales que dictaminen su custodia y cuando ya no sea necesario para ello, se suprimirán con medidas de seguridad adecuadas para garantizar la anonimización de los datos o la destrucción total de los mismos.",
      a_quien_facilitamos: "¿A quién facilitamos tus datos personales?",
      a_quien_facilitamos_text1:
        "No está prevista ninguna comunicación de datos personales a terceros salvo, si fuese necesario para el desarrollo y ejecución de las finalidades del tratamiento, a nuestros proveedores de servicios relacionados con comunicaciones, con los cuales el RESPONSABLE tiene suscritos los contratos de confidencialidad y de encargado de tratamiento exigidos por la normativa vigente de privacidad o exista obligación legal.",
      a_quien_facilitamos_text2:
        "Los datos facilitados al cumplimentar los formularios para la inscripción en los procesos de selección de personal, podrán ser comunicados a diferentes empresas ofertantes de prácticas y/o empleo, con la finalidad de estudiar su solicitud, y en su caso, el comienzo del proceso de selección, así como el mantenimiento del perfil del candidato (posible envío de comunicados, confirmación de inscripción a ofertas, cambios de estado en las candidaturas, entre otros) y llevar a cabo la gestión de posibles solicitudes de empleo.",
      cuales_son_tus_derechos: "¿Cuáles son tus derechos?",
      cuales_son_tus_derechos_text1: "Los derechos que asisten al USUARIO son",
      cuales_son_tus_derechos_text2:
        "Derecho a retirar el consentimiento en cualquier momento.",
      cuales_son_tus_derechos_text3:
        "Derecho de acceso, rectificación, portabilidad y supresión de sus datos, y de limitación u oposición a su tratamiento.",
      cuales_son_tus_derechos_text4:
        "Derecho a presentar una reclamación ante la autoridad de control (www.aepd.es) si considera que el tratamiento no se ajusta a la normativa vigente.",
      datos_contacto_derechos: "Datos de contacto para ejercer sus derechos",
      datos_contacto_derechos_text1:
        "EUNCET FORMACIÓN SL. Camí del Mas Rubial, núm. 1 - 08225 Terrassa (Barcelona). E-mail datos@euncet.com",
      datos_contacto_derechos_text2:
        "Datos de contacto del delegado de protección de datos info@badia-adv.com,",
      caracter_obligatorio_o_facultativo:
        "2. CARÁCTER OBLIGATORIO O FACULTATIVO DE LA INFORMACIÓN FACILITADA POR EL USUARIO",
      caracter_obligatorio_o_facultativo_text1:
        "El USUARIO, mediante la marcación de las casillas correspondientes y la entrada de datos en los campos, acepta expresamente y de forma libre e inequívoca, que sus datos son necesarios para atender su petición. El RESPONSABLE indicará qué datos son necesarios para la prestación de un servicio óptimo al USUARIO. En caso de que no se faciliten dichos datos, no se garantiza que la información y servicios facilitados sean completamente ajustados a sus necesidades. El USUARIO garantiza que los datos personales facilitados al RESPONSABLE son veraces y se hace responsable de comunicar cualquier modificación de los mismos.",
      medidas_de_seguridad: "3. MEDIDAS DE SEGURIDAd",
      medidas_de_seguridad_text1:
        "Que de conformidad con lo dispuesto en las normativas vigentes en protección de datos personales, el RESPONSABLE está cumpliendo con todas las disposiciones de las normativas RGPD y LOPDGDD para el tratamiento de los datos personales de su responsabilidad, y manifiestamente con los principios descritos en el artículo 5 del RGPD, por los cuales son tratados de manera lícita, leal y transparente en relación con el interesado y adecuados, pertinentes y limitados a lo necesario en relación con los fines para los que son tratados.",
      medidas_de_seguridad_text2:
        "El RESPONSABLE garantiza que ha implementado políticas técnicas y organizativas apropiadas para aplicar las medidas de seguridad que establecen el RGPD y la LOPDGDD con el fin de proteger los derechos y libertades de los USUARIOS y les ha comunicado la información adecuada para que puedan ejercerlos.",
      medidas_de_seguridad_text3:
        "Para más información sobre las garantías de privacidad, puedes dirigirte al RESPONSABLE a través de EUNCET FORMACIÓN SL. Camí del Mas Rubial, núm. 1 - 08225 Terrassa (Barcelona). E-mail datos@euncet.com",
      medidas_de_seguridad_text4:
        "Datos de contacto del delegado de protección de datos info@badia-adv.com",
    },
    footer: {
      campus: [
        {
          title: "CAMPUS BARCELONA CAN DRAGÓ",
          subtitle: "Nou Barris · Parc Can Dragó",
          direction: "C/ de Rosselló i Pòrcel, 7, 11 A, 08016, Barcelona",
          tel: "937 30 17 43",
        },
        {
          title: "CAMPUS BARCELONA 22@",
          subtitle: "Sant Martí",
          direction: "C/ de Badajoz, 145, Sant Martí, 08018 Barcelona",
          tel: "930 33 33 30",
        },
        {
          title: "CAMPUS TERRASSA",
          subtitle: "Parc de Sant Llorenç del Munt i l'Obac",
          direction: "C/ Camí del Mas Rubial, 1, 08225, Terrassa",
          tel: "935 47 60 66",
        },
      ],
    },
    propuesta_practicas: {
      cabecera_empresas: "Si un alumno/a va a realizar prácticas en su empresa, puede dar de alta aquí todos los detalles. Valoraremos y formalizaremos su propuesta si, tanto las prácticas ofertadas como el candidato/a seleccionado/a, cumplen con los requisitos exigidos.",
      datos_alumno: "Datos del alumno/a",
      introduce_dni: "Introduce el DNI de candidato/a.",
      dni: "DNI/NIE/Pasaporte",
      validar_candidato: "Validar candidato/a",
      comprueba_datos: "Comprueba que los datos del candidato/a coinciden. Si tienes dudas, o hay algún error escríbenos a",
      nombre: "Nombre del candidato/a",
      selecciona_titulacion: "Selecciona una titulación",
      list_selecciona_titulacion: "Haz clic para seleccionar una titulación",
      titulacion_candidato: "Titulación del candidato/a",
      cabecera_alumno: "Si has encontrado una empresa en la que realizar tus prácticas académicas curriculares o extracurriculares, puedes darla de alta aquí. La valoraremos y asignaremos si cumple con todos los requisitos exigidos.",
      desconocido: 'Si desconoces algún dato por favor indícanos "desconocido"',
      datos_academicos: "Datos académicos",
      paso_1: "Paso 1 de 4",
      paso_2: "Paso 2 de 4",
      paso_3: "Paso 3 de 4",
      tipo_propuesta: "¿Qué tipo de práctica vas a solicitar/proponer?",
      curricular: "Curricular",
      extracurricular: "Extracurricular",
      datos_empresa: "Datos de la empresa",
      introduce_cif: "Introduce el CIF de la empresa, donde vas a realizar las practicas.",
      cif_o_nif: "CIF (empresa) o NIF (autónomo)",
      validar_empresa: "Validar empresa",
      comprueba_datos_alumno: "Comprueba que los datos de la empresa coinciden con los datos de la empresa donde vas a realizar las prácticas. En caso tener una duda, o haber algun error escríbenos a",
      nombre_empresa: "Nombre de la empresa",
      cif_empresa: "Cif de la empresa",
      datos_contacto: "Datos del contacto de la empresa",
      introduce_email_contacto: "Introduce el email de tu contacto en la empresa.", 
      validar_contacto: "Validar contacto",
      comprueba_datos_contacto: "Comprueba que los datos de la empresa coinciden con los datos del contacto. En caso tener una duda, o haber algun error escríbenos a",
      nombre_contacto: "Nombre del contacto",
      email_contacto: "Email del contacto",
      no_existe_cif: "El CIF proporcionado no existe en nuestra base de datos, por favor rellena los siguientes campos.",
      datos_firmante: "A continuación introduce los datos del representante legal de la empresa que firmará los convenios:",
      no_exite_contacto: "No tenemos datos en nuestra base de datos de tu contacto, por favor rellena los datos.",
    }
  },
  ca: {
    guardar: "Guardar",
    volver: "< Tornar",
    sin_definir: "Sense definir",
    guardar_datos: "Guardar dades",
    cancelar: "Cancel·lar",
    confirmar: "Confirmar",
    eliminar: "Eliminar",
    aceptar: "Acceptar",
    rechazar: "Rebutjar",
    comenzar: "Començar",
    cerrar_sesion: "Tancar sessió",
    ver_menos: "Veure menys",
    ver_mas: "Veure més",
    inicio: "Inici",
    ver_detalles: "Veure detalls",
    guardar: "Guardar",
    editar: "Editar",
    anadir: "Afegir",
    enviar: "Enviar",
    requerido: "Requerit",
    revisar: "Revisar",
    editar_oferta: "Editar oferta",
    duplicar_oferta: "Duplicar oferta",
    cerrar_oferta: "Tancar oferta",
    eliminar_oferta: "Eliminar oferta",
    ver_como_candidato: "Veure com a candidat",
    practicas: "Pràctiques",
    empleo: "Treball ",
    ver: "Veure",
    enlaces: {
      politica_privacidad: "/politica-de-privacidad",
      politica_cookies: "/politica-de-cookies",
      login: "/login",
      solicitar_cuenta: "/solicitar-cuenta",
      registroalumno: "/registroalumno",
      encuestas: "/encuestas",
      encuesta: "/encuesta",
      eventos: "/eventos",
      eventospublico: "/evento-publico",
      documentacion: "/documentacion",
      guiaOrientacion: "/guias-orientacion",
      ofertas_practicas: "/ofertas-practicas",
      ofertas_empleo: "/ofertas-empleo",
      cv: "/cv",
      vercv: "/ver-cv",
      mis_candidaturas: "/mis-candidaturas",
      mis_practicas: "/mis-practicas",
      orientacion: "/orientacion-laboral",
      propuesta_practicas: "/propuesta-practicas",
      programapracticasactivos: "/programas-practicas-activos",
      solicitarcambiopracticas: "/solicitar-cambio-practicas",
      subirconvenio: "/subir-convenio-firmado",
      generarnuevoconvenio: "/nuevo-convenio-colaboracion",
      practicaseducacion: "/solicitudes-practicas-educacion",
      nueva_oferta: "/nueva-oferta",
      editar_oferta: "/editar-oferta",
      mi_empresa: "/mi-empresa",
      mi_perfil: "/mi-perfil",
      mis_ofertas: "/mis-ofertas",
      mi_oferta: "/oferta",
      programa_practicas: "/programa-practicas",
      visualizar_oferta: "/visualizar-oferta",
      restablecer_login: "/restablecer-login",
      restablecer_candidato: "/restablecer-candidato",
      setear_pass: "/establecer-login",
      proteccion_datos: "/proteccion-de-datos",
      acceso_saml: "/acceso",
      logout: "/logout",
      ayuda: "/ayuda",
      condicionespracticasuib: "/EUNCET/condiciones-practicas",
      formulario_datos: "/formulario-datos",
    },
    encabezado: {
      home: "Portal de treball i pràctiques",
      cv: "El meu currículum",
      cv_view: "Currículum del candidat",
      eventos: "Esdeveniments",
      propuesta_practicas: "Proposta de pràctiques",
      politica_privacidad: "Política de privacitat",
      politica_cookies: "Política de cookies",
      login: "Inici de sessió",
      solicitar_cuenta: "Nova empresa",
      registro_alumno: "Registre",
      ofertas_practicas: "Llistat d'ofertes de pràctiques",
      ofertas_empleo: "Llistat d'ofertes de treball",
      ficha_oferta_alumno_empleo: "Llistat d'ofertes de treball",
      ficha_oferta_alumno_practicas: "Llistat d'ofertes de pràctiques",
      mis_candidaturas: "Les meves candidatures",
      mis_practicas: "Les meves pràctiques",
      encuestas: "Enquestes",
      orientacion: "Orientació laboral",
      nueva_oferta: "Nova oferta",
      editar_oferta: "Editar oferta",
      mi_empresa: "La meva empresa",
      mi_perfil: "El meu perfil",
      documentacion: "Documentació",
      guiasOrientacion: "Guies Orientació",
      documentacion_empresa: "Documentació",
      documentacion_alumno: "La meva documentació",
      mis_ofertas: "Les meves ofertes",
      mi_oferta: "La meva oferta",
      ficha_oferta_empresa: "La meva oferta",
      restablecer_login: "Restablir Contrasenya",
      restablecer_candidato: "Restablir Contrasenya",
      programapracticasactivos: "Programes de pràctiques actius",
      setear_pass: "Establir Contrasenya",
      proteccion_datos: "Protecció de dades",
      visor_oferta: "Veure com a estudiant",
      fichaProgramaActivo: "Programes actius",
      solicitudCambioPracticas: "Sol·licitud canvi de pràctiques",
      solicitudesEducacion: "Sol·licituds ofertes educació",
      subirConvenioFirmado: "Pujar conveni signat",
      generarNuevoConvenio: "Nou conveni de Col·laboració",
      ayuda: "Ajuda",
      condicionespracticasuib: "Condicions pràctiques",
      info_alumno:
        "Recorda que si vols realitzar pràctiques fins al 15 de setembre no has de sol·licitar el títol fins a passada aquesta data. En el cas de sol·licitar el títol abans del 15 de setembre perdràs la condició d'estudiant i ja no podràs realitzar pràctiques.",
      formulario_datos: "Formulari dades",
      formulario_incorporacion: "Formulari d' incorporació",
      falta_num_ss:
        "Degut a l'entrada en vigor del nou RD el reial decret llei 2/2023, de 16 de març, que va entrar en vigor l'1 de gener 2024, és OBLIGATORI que ens facilitis el teu número d'afiliació a la Seguretat Social. Accedeix al teu perfil per a omplir aquesta informació",
    },
    ficha_oferta: {
      texto_programa_anadido:
        "Tens aquest programa afegit a la teva llista de programes informàtics",
    },
    formulario: {
      nombre: "Nom",
      nombre_apellidos: "Nom i cognoms",
      apellidos: "Cognoms",
      email: "Email",
      mensaje: "Missatge",
      fecha_nacimiento: "Data de naixement",
      dia: "Dia",
      mes: "Mes",
      anyo: "Any",
      area_interes: "Àrea del seu interès",
      trabaja_actualmente: "Treballa actualment?",
      si: "Si",
      no: "No",
      carta_presentacion: "Carta de presentació",
      meses: {
        Enero: "Gener",
        Febrero: "Febrer",
        Marzo: "Març",
        Abril: "Abril",
        Mayo: "Maig",
        Junio: "Juny",
        Julio: "Juliol",
        Agosto: "Agost",
        Septiembre: "Setembre",
        Octubre: "Octubre",
        Noviembre: "Novembre",
        Diciembre: "Desembre",
      },
      archivo_adjunto: "Adjuntar arxiu",
      adjuntar_cv: "Adjuntar CV",
      introduce_mail: "Introdueix el teu email",
      pais: "País",
      telefono: "Telèfon",
      he_leido: "He llegit i accepto la",
      y_acepto: "política de privacitat",
      enviar: "Enviar",
      enviado: "Enviat",
    },
    meses: [
      "Gener",
      "Febrer",
      "Març",
      "Abril",
      "Maig",
      "Juny",
      "Juliol",
      "Agost",
      "Setembre",
      "Octubre",
      "Novembre",
      "Desembre",
    ],
    login: {
      iniciar_sesion: "LOGIN",
      acceder: "Accedir",
      email: "Email",
      error_mail:
        "Si us plau, indica el mateix email que figura en el teu accés al Campus d'Euncet per per accedir al portal.",
      contrasena: "Contrasenya",
      repetir_contrasena: "Repetir Contrasenya",
      contrasena_olvidada: "Generar / recuperar contrasenya",
      introduce_email: "Introdueix el teu email",
      email_mal: "",
      recuperar_pass: "Recuperar la meva contrasenya",
      aun_no_registrado: "Encara no estàs registrat/da?",
      acceder_SSO: "",
      indica_mail: "",
      selecciona_empresa:
        "Si us plau, selecciona l'empresa amb la qual vols accedir.",
      titulacion: "Titulació",
      tipo_formacion: "Tipus de formació acadèmica",
      selecciona_formacion: "Selecciona un tipus de formació",
      registrarme: "Registrar-me",
      deseo_recibir:
        "Desitjo rebre comunicacions relacionades amb EUNCET i amb serveis relacionats amb formació superior. ",
      popup_rgpd: {
        titulo: "INFORMACIÓ AMPLIADA",
        detalle:
          "Si necessites ampliar informació més detallada, pots accedir a la Política de Protecció de Dades a",
        enlace: "aquest enllaç.",
        boton: "Consento, accedir",
      },
      restablecer_pass: {
        titulo: "Segueix els passos per restablir la teva contrasenya",
        intro: "La contrasenya ha de contenir almenys 8 caràcters i un número.",
        guardar: "Guardar",
      },
      seteo_pass: {
        titulo: "Segueix els passos per establir la teva contrasenya",
        intro: "La contrasenya ha de contenir almenys 8 caràcters i un número.",
        guardar: "Guardar",
      },
    },
    registro: {
      encabezado:
        "Omple el formulari que hi ha a continuació per donar-te d'alta al sistema",
      datos_usuario: "Dades de l'usuari d'empresa",
      datos_personales: "Dades personals",
      nombre: "Nom",
      apellidos: "Cognoms",
      DNI: "DNI/NIF/NIE",
      CIF: "CIF de l'empresa",
      puesto: "Lloc / Càrrec",
      departamento: "Departament",
      telefono_1: "Telèfon 1",
      telefono_2: "Telèfon 2",
      email: "Email",
      sede: "Seu per defecte",
      cargo: "Càrrec",
      idioma: "Idioma preferit de comunicació",
      tipo_contacto: "Tipus de Contacte",
      contrasena: "Contrasenya",
      repetir_contrasena: "Repetir Contrasenya",
      direccion: "Direcció",
      pais: "País",
      selecciona_pais: "-selecciona un país-",
      provincia: "Província",
      selecciona_provincia: "-Selecciona una província-",
      localidad: "Localitat",
      selecciona_localidad: "-Selecciona una localitat-",
      direccion: "Direcció",
      direccion_empresa: "Direcció Empresa",
      cp: "Codi Postal",
      titulo_2:
        "A continuació introdueix les dades de la teva empresa per donar-te d'alta al sistema",
      anadir_imagen: "Fes click per afegir l'imatge",
      autorizar_logo: "Autoritzar ús del logo",
      nombre_fiscal: "Nom fiscal o Raó social",
      email_empresa: "Email d'empresa",
      cp: "Codi postal",
      nombre_comercial: "Nom comercial",
      tipo_sociedad: "Tipus de Societat",
      selecciona_tipo_sociedad: "-Selecciona tipus de societat-",
      tipo_empresa: "Tipus d'empresa",
      privada: "Privada",
      publica: "Pública",
      startup: "Startup",
      eliminar: "Eliminar",
      descripcion: "Descripció",
      si: "Sí",
      no: "No",
      sector: "Sector",
      selecciona_sector: "-Selecciona un sector-",
      otro_sector: "Un altre Sector",
      numero_empleados: "Número d' empleats",
      selecciona_empleados: "-Selecciona un rang-",
      web: "Web",
      iban: "Número compte IBAN",
      descripcion_empresa: "Descripció de l'empresa",
      femenino: "Femení",
      masculino: "Masculí",
      telefono: "Telèfon",
      firmante: {
        titulo:
          "A continuació introdueix les dades de la persona que actua com a representant legal de l'empresa i que serà qui signarà els convenis",
        no_obligatorio: "(no és obligatori, es pot indicar més endavant)",
        nombre: "Nom del signant",
        apellidos: "Cognoms del signant",
        email: "Email del signant",
        dni: "DNI del signant",
        cargo: "Càrrec del signant",
        telefono: "Telèfon",
      },
      contacto: {
        nombre: "Nom del contacte",
        apellidos: "Cognoms del contacte",
        email: "Email del contacte",
        telefono: "Telèfon",
      },
      envio_facturas: {
        titulo: "Adreça enviament de factures",
        titulo_2: "Direcció de facturació",
      },
      anadir_direccion: "Afegir nova direcció de facturació",
      perfil_sectorial: "Perfil sectorial",
      sector_actividad: "Sector d'activitat",
      selecciona_sector_actividad: "-Selecciona un sector-",
      rango: "Rang de facturació",
      selecciona_rango: "-Selecciona un rang-",
      numero_empleados: "Nombre d'empleats",
      selecciona_numero_empleados: "-Selecciona un rang-",
      anyo_fundacion: "Any de fundació",
      politica_1: "He llegit i accepto la,",
      politica_2: "política de privacitat",
      nuevo_contacto_titulo: "Dades del nou contacte de gestió",
      anadir_contacto: "Afegir contacte",
      nueva_cuenta_fiscal: "Dades del nou compte fiscal",
      domicilio_fiscal: "Domicili Fiscal",
      poblacion: "Població",
      requiere_envio_postal: "Requereix enviament postal de les factures",
      domicilio_postal: "Domicili per a l'enviament postal de factures",
      anadir_cuenta: "Afegir compte",
      datos_firmante: "Dades del signant",
      area_conocimiento: "Àrea o branca de coneixement",
      nombre_titulacion: "Nom de la titulació",
      ano_inicio: "Any d'inici",
      ano_finalizacion: "Any de finalització",
      solicitar_cuenta: "Sol·licitar compte",
      seguir_empresa: "Seguir amb les dades de l'empresa",
      registrar_empresa: "Registrar Empresa",
      dni_pasaporte_nie: "DNI/NIF/NIE/Passaport",
      selecciona_nivel: "-Selecciona un nivell-",
      busca_area: "Busca l'àrea",
      busca_titulacion: "Busca la titulació",
      firmaDigital: "Tipus de signatura per al conveni ",
      asume_coste_SS:
        "¿Su entidad acepta asumir el cumplimiento, gestión y coste de las obligaciones en materia de Seguridad Social de los estudiantes que realicen prácticas formativas o prácticas académicas externas en su institución, tal y como recoge el Real Decreto-ley 2/2023?",
      asume_coste_SS_Si:
        "Si, aceptamos asumir el cumplimiento, gestión y coste de las obligaciones de la Seguridad Social del estudiante, en el momento que sea de aplicación efectiva tal y como recoge el Real Decreto-ley 2/2023.",
      asume_coste_SS_No:
        "No Aceptamos. Solicitamos que sea EUNCET, la entidad que asuma el cumplimiento, gestión y coste de las obligaciones de la Seguridad Social del estudiante, en el momento que sea de aplicación efectiva tal y como recoge el Real Decreto-ley 2/2023.",
    },
    home_empresa: {
      ofertas_practicas: "OFERTES<strong>De pràctiques</strong>",
      texto_ofertas_practicas:
        "Consulta i gestiona les ofertes de pràctiques i les candidatures rebudes.",
      nueva_practicas: "PUBLICAR<strong>Nova oferta de pràctiques",
      publicar_practicas:
        "Publica ofertes de pràctiques, dirigides a els/les nostres estudiants.",
      nueva_propuesta: "DEMANAR PRÀCTICA<strong>Proposta de pràctiques",
      publicar_propuesta:
        "Si ja tens seleccionada la persona que realitzarà la pràctica, fes la teva proposta de pràctiques per a aquest/a estudiant aquí.",
      ofertas_empleo: "OFERTES<strong>De treball",
      texto_ofertas_empleo:
        "Consulta i gestiona les ofertes d' ocupació i les candidatures rebudes.",
      nueva_empleo: "PUBLICAR<strong>Nova oferta de treball",
      texto_nueva_empleo: "Publica ofertes de treball",
    },
    mi_practica: {
      subir_documentacion: "Pujar documentació",
      descargar_anexo: "Descarregar Annex Signat",
      descargar_certificado:
        "Descarregar certificat de realització de pràctiques",
      descargar_poliza: "",
      titulo_practicas:
        "Per poder incorporar-te a la realització d' aquestes pràctiques és necessari",
      pagar_creditos: "Pagar els crèdits que s' han de reconèixer.",
      descarga: "Descàrrega",
      aqui: "aquí",
      documento_pago: "",
      contratar_poliza: "",
      puedes_contratar: "",
      mensaje_documentos: "",
      digitaliza_documentos: "",
      adjuntar_pago: "Adjuntar resguard de pagament",
      adjuntar_seguro: "Adjuntar pòlissa d' assegurança",
      descarga_ficheros:
        "Descarrega els fitxers següents, signa'ls i adjunta'ls de nou.",
      enviar: "Enviar",
      renuncia_practicas_SET:
        "Aquestes pràctiques extracurriculars formaran part del teu SET (Suplement Europeu al Títol) si compleixes els requisits exigits legalment, en cas que no desitgis que s'uneixin a SET, has d'adjuntar el document de renúncia signat. Pots descarregar la plantilla del document",
      adjuntar_renuncia: "Adjuntar renúncia signada",
    },
    mis_practicas: {
      titulo:
        "En aquesta secció trobaràs tota la documentació referent a les teves pràctiques.",
      zero_1: "No hi ha cap pràctica o documentació de pràctiques per mostrar.",
    },
    cambio_password: {
      titulo: "Canviar contrasenya",
      titulo_candidato: "Desitges canviar la teva contrasenya?",
      contrasena_actual: "Contrasenya actual",
      nueva_contrasena: "Nova Contrasenya",
      repetir_contrasena: "Repetir nova Contrasenya",
    },
    guia_orientacion: {
      titulo:
        "A continuació posem a la teva disposició documents en relació amb les teves pràctiques o ocupació, consells i bones pràctiques que poden ser del teu interès.",
      zero: "No hi ha guies d'orientació",
    },
    mi_empresa: {
      intro: {
        cuerpo:
          "Es mostren a continuació les dades principals de la seva empresa. Si alguna no és correcta, o necessita accedir, corregir, o eliminar qualsevol detall de la seva informació enviï un e-mail a careers.services@euncet.com.",
        porfavor: "Si té qualsevol dubte, si us plau, ",
        contacte: "contacti amb nosaltres.",
      },
      datos_empresa: "Dades de l'empresa",
    },
    formulario_datos: {
      intro: {
        cuerpo:
          "Es mostren a continuació les dades principals de la seva empresa. Actualitzi o empleni la següent informació de la seva empresa.",
        porfavor: "Si us plau, ",
        contacte: "contacta amb nosaltres.",
      },
      datos_empresa: "Dades de l'empresa",
      datos_firmante: "Dades del signant",
      datos_contacto: "Dades del contacte",
    },
    candidaturas_options: {
      aceptar: "Acceptar inscripció",
      rechazar: "Rebutjar inscripció",
      motivos_rechazo: "Motius del rebuig",
      selecciona_motivo: "- Selecciona un motiu de rebuig -",
      rechazar_preinscripcion: "Rebutjar preinscripció a l'oferta",
    },
    oferta: {
      intro_editor:
        "Per crear una nova oferta ha d'emplenar el formulari que hi ha a continuació",
      tipo_oferta: "Tipus d' oferta",
      numero_plazas: "Número de places",
      experiencia: "Experiència",
      experiencia_deseable: "Experiència desitjable",
      horario: "Horari",
      fecha_inicio: "Data d'inici",
      fecha_fin: "Data de finalització",
      tipo_contrato: "Tipus de contracte",
      salario: "Salari",
      creditos: "Crèdits superats",
      otras_remuneraciones: "Altres remuneracions",
      pais: "País",
      poblacion: "Població/Província",
      poblacion_only: "Població",
      provincia: "Província",
      sector: "Sector de l'empresa",
      categoria: "Categoria",
      area_funcional: "Àrea funcional",
      seleccione_provincia: "-Selecciona una província-",
      sede: "Seu/campus",
      beca: "Beca mensual",
      descripcion_puesto: "Descripció de l'oferta",
      tarea: "Funcions",
      tutores_disponibles: "Tutors disponibles",
      otras_tareas: "Altres funcions",
      programa_practicas: "Programa de pràctiques",
      aviso_programa: "Important consultar per comprovar requisits obligatoris",
      enlace_inscripcion: "Enllaç d'inscripció",
      ir_enlace: "Anar a l'enllaç",
      idiomas: "Idiomes",
      anadir_idiomas: "Afegir Idiomes",
      empleo: "Ocupació",
      practicas: "Pràctiques",
      certificacion: "Certificació mínima requerida",
      requerido: "Requisits",
      estudios_obligatorios: "Estudis als quals va dirigit",
      estudios_deseables: "Estudis desitjables",
      estudios_propuestos: "Estudis proposats",
      requisitos_obligatorios: "Requisits obligatoris",
      etiquetas: "Etiquetes",
      otros_obligatorios: "Altres obligatoris",
      edad_maxima: "Edat màxima",
      salario_maximo: "Salari Màxim",
      intereses_deseables: "Interessos desitjables",
      intereses_obligatorios: "Interessos obligatoris",
      intereses_seleccionados: "Interessos seleccionats",
      competencias_obligatorias: "Competències obligatòries",
      competencias_seleccionadas: "Competències seleccionades",
      paises_nacionalidad_obigatorios: "Països de Nacionalitat obligatoris",
      paises_residencia_obligatorios: "Països de Residència obligatoris",
      provincia_residencia_obligatorios: "Província de Residència obligatoris",
      paises_seleccionados: "Països seleccionats",
      provincias_seleccionados: "Províncies seleccionades",
      coche_propio: "Cotxe propi",
      obligatorio_quest: "Obligatori?",
      carnet_conducir: "Carnet de conduir",
      disponible_extranjero: "Disponibilitat per treballar a l'estranger",
      disponible_residencia: "Disponibilitat per a canvi de residència",
      trabajando_actualmente: "Treballant actualment",
      requisitos_deseables: "Requisits desitjables",
      otros_requisitos_deseables: "Altres Requisits desitjables",
      otros_requisitos_obligatorios: "Altres requisits obligatoris",
      motivos_exclusion: "Motius d' exclusió",
      competencias_deseables: "Competències desitjables",
      paises_nacionalidad_deseables: "Països de Nacionalitat desitjables",
      paises_residencia_deseables: "Països de Residència desitjables",
      provincia_residencia_deseables: "Província de Residència desitjables",
      programas_informaticos: "Programes informàtics",
      programas_informaticos_deseables: "Programes informàtics desitjables",
      documentos_requeridos: "Documents requerits",
      documentos: "Documents",
      marca_documentos:
        "Marca els documents que han d'aportar els candidats/es.",
      anadir_otro_documento: "Afegir un altre tipus de document",
      nombre_documento_candidato: "Nom del document a aportar pel candidat",
      inscribirme: "Inscriure'm",
      desinscribirme: "Desinscriure'm",
      ya_inscrito: "ja estàs inscrit",
      cancelar_inscripcion: "Cancel·lar inscripció",
      buscar_mas_intereses: "Busca més interessos",
      atencion: "Atenció!",
      tramitar_inscripcion:
        "Per tramitar la teva inscripció en aquesta oferta has de presentar la teva candidatura al web de l'empresa que ofereix.",
      acceder: "Per accedir-hi",
      pincha_aqui: "clica aquí.",
      especialidad: "Especialitat",
      estado: "Estat",
      datos_practica: "Dades de la pràctica",
      paso_4: "Pas 4 de 4",
      tareas_a_desarrollar: "Tasques a desenvolupar",
      horario: "Horari",
      horario_practicas: "Horari de pràctiques",
      horario_trabajo: "Horari de treball",
      tengo_candidato: "Tinc candidat/a",
      horas_dia: "Hores al dia",
      horas_semana: "Hores setmanals",
      remuneracion: "Remuneració (€ bruts/hora)",
      remuneracion_anual: "Remuneració bruta anual",
      otros_beneficios: "Altres beneficis",
      fecha_inicio: "Data d'inici",
      fecha_fin: "Data de fi",
      fecha_alta: "Data Alta",
      duracion_meses: "Durada (en mesos)",
      dedicacion: "Dedicació (% jornada)",
      departamento: "Departament",
      modalidad: "Modalitat",
      numero_dias_semana: "Número de dies per setmana",
      dias_semana: "Dies de la setmana",
      vinculado_tfg: "Vinculat a TFG",
      nombre_tfg: "Nom TFG",
      tutor_tfg: "Tutor/a TFG",
      solicitante: "Sol·licitant del servei",
      centro_practicas: "Centre de pràctiques",
      n_pedido: "Nº de comanda (si ho requereix)",
      observaciones: "Observacions",
      direccion: "Direcció",
      nombre_tutor_uni: "Nom i cognoms del tutor o tutora de la Universitat",
      datos_tutor_empresa: "Dades del tutor o tutora a l'empresa",
      nombre: "Nom",
      apellidos: "Cognoms",
      email: "Email",
      telefono: "Telèfon",
      cargo: "Càrrec",
      dni: "DNI",
      titulacion_especialidad: "Titulació o especialitat",
      titulacion: "Titulació/ Càrrec",
      selecciona: "-Seleccionar-",
      nombre_oferta: "Nom de l'oferta",
      numero_plazas: "Número de places",
      experiencia_requerida: "Experiència requerida",
      experiencia_deseable: "Experiència desitjable",
      opciones_publicacion: "Opcions de publicació",
      url_inscripcion: "URL inscripció empresa",
      candidato_preferido: "Candidat/a preferit/da",
      datos_realizacion: "Dades de realització de la pràctica",
      conocimientos_especificos: "Coneixements específics",
      formacion_adquirida: "Formació adquirida",
      seguimiento_previsto: "Seguiment previst",
      empresa_destino:
        "Empresa destinatària (només si és oferta d'una gestora/consultora ETT)",
      datos_tutor: "Dades del tutor/a de l'empresa",
      para_estudiantes_ultimo_ano: "Per estudiants d'últim any",
      curso_minimo_requerido: "Curs mínim requerit",
      para_perfil_no_universitario: "Per a perfil no universitari",
      activo_quest: "Actiu?",
      ano_promo_maximo: "Any de promoció màxim",
      enviar_quest: "Enviar?",
      candidato_leer: "Candidat/a per llegir",
      candidatos_leer: "Candidats/es per llegir",
      candidato_total: "Candidat/a en total",
      referencia: "Referència",
      candidatos_total: "Candidats/es en total",
      ver_detalles: "Veure detalls",
      con_practicas: "Amb pràctiques assignades",
      fecha_caducidad: "Data de caducitat",
      buscar_mas_programa: "Busca més programes informàtics",
      programas_elegidos: "Programes informàtics escollits",
      sin_programas: "Sense programes informàtics especificats",
      selecciona_idioma: "Selecciona un idioma",
      escribe_idioma: "Escriu aquí l'idioma",
      indica_certificacion:
        "Indica aquí la certificació o nivell mínim requerit",
      titulaciones: "Titulacions",
      requeridas: "requerides",
      deseables: "valorables",
      propuestas: "propostes",
      a_las_que: "a les quals s'adreça l'oferta",
      nivel: "Nivell",
      areas: "Àrees",
      cualquier_area: "Qualsevol àrea",
      ninguna_titulacion:
        "Cap titulació concorda amb el filtre de nivell indicat.",
      eliminar_todas: "Eliminar totes",
      areas_dirige: "Àrees a les quals s'adreça l'oferta",
      titulaciones_dirige: "Titulacions a les quals s'adreça l'oferta",
      selecciona_titulaciones:
        "Selecciona les titulacions al llistat de l'esquerra",
      cumplimentar:
        "Emplenar només en el cas de que consideri que és informació rellevant per als candidats/es.",
      tipo_estudios: "Tipus d' estudis",
      seleccione_izquierda: "Selecciona les àrees en el llistat de l'esquerra.",
      seleccione_algun_nivel:
        "Seleccioni algun nivell per carregar les àrees associades",
      especialidad_titulacion: "Especialitat o titulació",
      puesto_trabajo: "Posició de treball",
      motivo_rechazo: "Motiu de rebuig",
      ayuda_estudio: "Ajut a l'estudi",
      tutor_empresa: "Tutor/a de l'empresa",
      nombre_tutor: "Nom del tutor o tutora d'empresa",
      apellidos_tutor: "Cognoms del tutor o tutora d'empresa",
      email_tutor: "Email del tutor o tutora d'empresa",
      telefono_tutor: "Telèfon del tutor o tutora d'empresa",
      cargo_tutor: "Càrrec del tutor o turora d'empresa",
      titulacion_tutor: "Titulació del tutor o tutora d'empresa",
      departamento_tutor: "Departament del tutor o turora d'empresa",
      dni_tutor: "DNI del tutor o tutora d'empresa",
      no_definido: "No definit",
      candidatos: "Candidats/es",
      exportar: "Exportar",
      no_hay_candidatos: "No hi ha candidats/es per aquesta oferta",
      mas: "més",
      menos: "menys",
      empresa_destino_simple: "Empresa de destinació",
      tipo_formacion: "Tipus de formació",
      niveles: "Nivells",
      areas: "Àrees",
      para_estudiantes_ultimo_curso: "Per estudiants d'últim curs",
      duplicar_oferta_aviso:
        "Oferta duplicada correctament. Vols editar-la ara?",
      alumno_validado_uib: "Estudiant validat per EUNCET",
      condicionespracticas:
        "He llegit i estic d'acord amb les condicions. <a>Veure condicions</a>",
      idioma: "Idioma",
      ofertacerrada:
        "Una oferta tancada no estarà visible ni rebrà nous candidats. Estàs segur de voler tancar aquesta oferta?",
      eliminaroferta: "S'eliminarà l'oferta. Continuar avançant?",
      ofertaduplicada: "Oferta duplicada correctament. Vols editar-la ara?",
      controlCerraroferta:
        "Ha seleccionat algun dels candidats proposats per EUNCET?",
      cumplimentainformacion: "Si us plau, complimenti la següent informació",
      nombrepersona: "Nom i cognoms de la persona seleccionada",
      fechainiciocontrato: "Data d'inici del contracte",
      tipocontrato: "Tipus de contracte",
      nota_media: "Nota mitjana",
      observaciones: "Observacions",
      nombre_apellidos_dni: "Nom, cognoms i DNI",
      ocultar_datos_empresa: "Ocultar dades de l'empresa",
      url_informacion_complementaria: "URL per a informació complementària",
      fichero_informacion_complementaria: "Fitxer informació complementària",
      ver_fichero_adjunto: "Veure fitxer adjunt",
      datos_firmante: "Dades de la persona signant",
      firmante: {
        nombre: "Nom de la persona signant",
        apellidos: "Cognoms de la pesona signant",
        email: "Email de la persona signant",
        dni: "DNI de la persona signant",
        cargo: "Càrrec de la persona signant",
        telefono: "Telèfon",
      },
      num_Pedido: "Número de la comanda",
    },
    filtro_oferta: {
      buscar_nombre: "Busca per nom de la posició",
      buscar_localizacion: "Busca per localització",
      buscar_titulacion: "Busca per titulació",
      buscar_puesto: "Busca per nom de la posició",
      filtro_avanzado: "Filtre Avançat",
      cerrar: "Tancar",
      fecha_publicacion: "Data publicació",
      fecha_inicio_previsa: "Data prevista d'inici de la pràctica",
      fecha_inicio: "Data d'inici",
      filtrado_etiqueta: "Filtrat per etiquetes",
      omitir_inscritos: "Ometre ja inscrits",
      oferta_tfg: "Oferta TFG/TFM",
      ofertas_internacional: "Oferta internacional",
      ofertas_cv: "Ofertes que encaixen amb el meu perfil/cv",
      busquedas_guardadas: "Recerques guardades",
      guardar_busqueda: "Guardar recerca",
      borrar_filtros: "ESBORRAR FILTRES",
      ver: "Veure",
      fecha: "Data",
      ofertas_tfg: "Oferta TFG/TFM",
      se_han_encontrado: "s'han trobat",
      introduce_nombre_busqueda: "Introdueix el nom de la recerca",
      sobreescribe_existente: "o sobreescriu una existent",
      selecciona_busqueda: "Selecciona una recerca",
      ver_historico: "Veure històric d'ofertes",
      ver_actuales: "Veure ofertes actuals",
      crear_oferta: "CREAR OFERTA",
      historico_ofertas: "Històric d'ofertes",
      no_hay_ofertas: "No hi ha ofertes coincidents amb la teva recerca",
      solo_con_candidatos: "Només ofertes amb candidats/es sense llegir",
      tienen_candidatos: "Tenen candidats/es",
      caduca_pronto: "Prescriuen aviat",
      no_leidos: "Només no llegits",
      modalidad: "Modalitat",
      puesto_Empresa: "Lloc/ Empresa",
      buscar_sector: "Buscar per sector",
    },
    popup_confirmacion: {
      recuerda: "Recorda!",
      titulo:
        "Assegura't que les dades del teu perfil estan actualitzades abans d'inscriure't a una oferta.",
      actualiza: "Actualitza'l clicant",
      aqui: "aquí.",
      confirma_titulo:
        "Si us plau confirma que vols ser candidat/a en aquesta oferta.",
      atencion: "Atenció!",
      necesitamos_anadir:
        "Necessitem que afegeixis els següents documents per a poder inscriure't a l'oferta.",
      url_documento: "URL del document",
      por_favor_adjunta: "Si us plau, adjunta l'arxiu o url",
      alumnos_master:
        "Els estudiants de màster de 2 anys de durada han de tenir almenys el 50% dels crèdits aprovats, a data d' inici de realització de les pràctiques, per poder realitzar-les. Ets estudiant de màster de durada inferior a 2 anys, o has superat el 50% dels crèdits?",
      inscripcion_externa:
        "La inscripció d' aquesta oferta es realitza a través de la web de l' empresa.",
      confirma_inscripcion_externa:
        "Si us plau, confirma que vols ser redirigit al web de l'empresa per inscriure't a l'oferta.",
    },
    header: {
      hola: "Hola,",
      oferta_practicas: "Buscar ofertes de pràctiques",
      oferta_empleo: "Buscar ofertes de treball",
      propuesta_practicas: "Proposta de pràctiques",
      candidaturas: "Les meves candidatures",
      practicas: "Les meves pràctiques",
      programas: "Programes",
      encuestas: "Enquestes",
      eventos: "Esdeveniments",
      mi_cv: "El meu CV",
      guias_orientacion: "Guies Orientació",
      mis_ofertas: "Les meves ofertes",
      nueva_oferta: "Nova oferta",
      solicitar_cambio_practicas: "Sol·licitar canvi de pràctiques",
      documentacion: "Documentació",
      solicitudes_practicas_educacion: "Sol·licituds pràctiques educació",
      encuestas: "Enquestes",
      mi_empresa: "La meva empresa",
      ayuda: "Ajut",
      cerrar_sesion: "Tancar sessió",
      solicitar_baja: "Sol·licitar baixa",
      formulario_datos: "Formulari dades",
    },
    image_uploader: {
      titulo: "Editar imatge de perfil",
    },
    notificaciones: {
      borrar_todo: "Esborrar tot",
      importantes: "Importants",
      otras_notificaciones: "Altres notificacions",
      no_notificaciones: "No tens notificacions pendents",
    },
    popup_borrar_cuenta: {
      titulo:
        "Desitja sol·licitar la baixa del servei i la supressió de les seves dades personals?",
      si: "Sí",
      no: "No",
    },
    popup_faltan_datos_empresa: {
      atencion: "Atenció!",
      cuerpo_1:
        "Falten dades obligatòries al teu perfil, si us plau accedeix per completar-les.",
      cuerpo_2:
        "Falten dades obligatòries al perfil de la teva empresa, si us plau omple-les.",
      ir_a_perfil: "Anar al meu Perfil",
      ir_a_empresa: "Anar a La meva empresa",
    },
    popup_datos_personales: {
      atencion: "Atenció!",
      titulo:
        "Falten dades obligatòries al teu perfil, si us plau accedeix per omplir-les.",
      ir_a_perfil: "Anar al meu Perfil",
    },
    solicitudes_educacion: {
      titulo:
        "En aquest apartat trobaràs la informació dels estudiants que han sol·licitat la realització de pràctiques en el seu centre.",
      zero: "No hi ha documentació en aquests moments.",
    },
    filtro_candidaturas: {
      buscar_nombre: "Busca per nom de la posició",
      empleo: "Treball  ",
      practicas: "Pràctiques",
      filtro_avanzado: "Filtre Avançat",
      cerrar: "Tancar",
      estado: "Estat",
      ver: "Veure",
      borrar_filtros: "ESBORRAR FILTRES",
      estas_en: "Estàs a",
      zero: "No hi ha cap procés de selecció coincidents amb la teva recerca",
    },
    documentacion: {
      intro:
        "En aquest apartat trobaràs la documentació relacionada amb les pràctiques que s'han realitzat a la teva empresa.",
      convenio_titulo: "Convenis de col·laboració",
      caducado: "(Caducat) -",
      zero_convenio: "Encara no tens cap conveni",
      titulo_convenio:
        "Si ho desitges pots sol·licitar i descarregar el conveni de col·laboració, o afegir el document ja signat per la teva empresa",
      nuevo_convenio: "Nou conveni",
      subir_convenio: "Pujar conveni signat",
      anexos_practicas: "Annexos de pràctiques",
      zero_practicas: "Encara no tens contingut",
      notas_formativas: "Notes formatives",
      en: "a",
      otros_documentos: "Altres documents associats ",
      zero_documentos: "Encara no tens cap document associat",
      otros_documentos_programas: "Altres documents de programes",
      zero_documentos_practicas:
        "Encara no tens cap document associat a pràctiques",
      documentos_aportados_empresa: "Altres documents aportats per l'empresa",
      no_documentos_anadidos:
        "No hi ha documents adjunts, pulsa per adjuntar un",
      anadir_documentacion: "Afegir documentació",
      selecciona_documento: "Selecciona un document",
      listado_documento: "Llistat de documents",
      otro_tipo_documento: "Un altre tipus de document",
      nombre_documento: "Nom del document",
      url_documento: "URL del document",
    },
    encuestas: {
      titulo: "Enquestes",
      obligatorias: "Per continuar, respon a totes les preguntes obligatòries",
      enviar: "Enviar",
      siguiente: "Següent",
      empezar_de_nuevo: "Començar de nou",
      pagina: "Pàgina",
      datos_enviados: "Les teves dades han estat enviades",
      muchas_gracias: "Moltes gràcies!",
      iniciar_sesion: "Inicia sessió amb el teu usuari de perfil",
      empresa: "Empresa",
      candidato: "Candidat",
      usuario: "Usuari",
      contrasena: "Contrasenya",
      acceder: "Accedir",
      o: "o",
      acceder_anonimamente: "Accedir de forma anònima",
      contestar_pregunta: "Has de respondre aquesta pregunta per continuar",
      zero: "No hi ha enquestes disponibles",
      titulo: "Enquestes Pendents",
      cuerpo: "Si us plau, abans de continuar, respongui a aquestes enquestes",
      no_puedes:
        "No pots accedir al portal fins que no hagis respost les enquestes pendents. Si no desitges respondre en aquest moment, pots tancar la teva sessió.",
    },
    eventos: {
      proximos: "Pròxims esdeveniments",
      pasados: "Esdeveniments passats",
      evento_destacado: "Esdeveniment destacat",
      desde: "Des de",
      hasta: "Fins a",
      organizado_por: "Organitzat per",
      inscribirse: "Inscriure' t",
      inscrito: "Inscrit",
      mas_informacion: "Més informació",
      galeria: "Galeria d' imatges",
      videos: "Vídeos",
      buscar_localizacion: "Buscar per localització",
      buscar_categoria: "Buscar per categoria",
      buscar_nombre: "Buscar per nom",
      eventos_pasados: "Esdeveniments ja passats",
      ver_mas: "Veure més",
    },
    comunicaciones: {
      titulo: "Comunicacions",
    },
    guias: {
      titulo: "Últimes guies d'orientació",
      zero: "No hi ha guies d'orientació",
    },
    ofertas: {
      ultimas_practicas: "Últimes ofertes de pràctiques",
      practicas: "Pràctiques",
      ultimas_empleo: "Últimes ofertes de treball",
      empleo: "Treball",
      ofertas: "Ofertes",
      zero_ofertas: "No hi ha ofertes disponibles.",
      contrato: "Contracte",
      idContrato: "Contracte",
      salario: "Salari",
      areaFuncional: "Àrea Funcional",
      provincia: "Província",
      areasTitulaciones: "Àrees de titulacions",
      nivelesTitulaciones: "Nivells de titulacions",
      tiposFormacion: "Tipus de formació",
      tituloPrograma: "Programa",
      area: "Àrea",
      filtrar_titulacion: "Filtrar per titulació",
      tipoModalidadAsistencia: "Modalitat d'assistència",
    },
    cv: {
      nivel: "Nivell",
      programa_informatico: "Programa informàtic",
      certificado: "Certificat",
      sin_nivel: "Sense nivell definit",
      presentacion: "Presentació",
      anadir_presentacion: "Per afegir la teva presentació clica",
      aqui: "aquí",
      otros_intereses: "Altres interessos",
      tus_interes: "Els teus interessos",
      sin_intereses: "Sense interessos específics",
      escribe_interes: "Escriu algun interès, per començar a buscar",
      click_interes: "Fes click sobre l'interès, per afegir-lo",
      click_cambiar_imagen: "Fes click per canviar la imatge",
      cambiar_contrasena: "Canviar contrasenya",
      idiomas: "Idiomes",
      idioma: "Idioma",
      sin_idiomas: "Sense idiomes afegits, clica a afegir idioma per afegir-lo",
      idioma_obligatorio:
        "L' idioma i el nivell són camps obligatoris per afegir un idioma",
      nivel_no_definido: "Nivell no definit",
      nivel: "Nivell",
      nombre_certificado: "Nom del certificat",
      estancia_extranjero: "Estada a l'estranger",
      pais_estancia: "País d'estada",
      motivo_estancia: "Motiu de l'estada",
      duracion_meses: "Durada en mesos",
      experiencia_profesional: "Experiència professional",
      anadir_nueva_experiencia: "Afegir nova experiència",
      sin_experiencia: "Sense experiència",
      nivel_formativo: "Nivell formatiu",
      actualidad: "Actualitat",
      puesto: "Nom de la posició",
      anadir_documento: "Afegir document",
      sector_empresa: "Sector de l'empresa",
      area_actividad_puesto: "Àrea d'activitat de la posició",
      tipo_contrato: "Tipus de contracte",
      subtipo_contrato: "Subtipus de contracte",
      ver_adjunto: "Veure adjunt",
      ver_enlace: "Veure enllaç",
      duracion: "Durada",
      fecha_inicio: "Data d'inici",
      fecha_fin: "Data de fi",
      provincia: "Província",
      empresa: "Empresa",
      enlace: "Enllaç",
      descripcion_puesto: "Descripció de la posició",
      escribe_descripcion: "Escriu una descripció de les tasques exercides",
      anadir_fichero: "Adjuntar fitxer",
      adjunto_correctamente: "Arxiu adjunt correctament",
      isla: "Illa",
      programas_informaticos: {
        titulo: "Programes informàtics",
        buscar: "Escriu per buscar",
        zero: "No hi ha programes informàtics afegits, clica a afegir per afegir-los",
        anadir: "Afegir Programa",
      },
      sectores_interes: {
        titulo: "Sectors d'interès",
        buscar: "Escriu per buscar",
        zero: "No hi ha sectors d'interès afegits, clica a afegir per afegir-los",
        anadir: "Afegir sector d'interès",
      },
      documentacion_adjunta: "Documentació adjunta",
      documentacion_subida: "Documentació pujada el",
      no_hay_documentos: "No hi ha documents afegits",
      pulsa_anadir_documentos: "clica a afegir document per afegir-lo",
      anadir_documentacion: "Afegir documentació",
      selecciona_documento: "Selecciona un document",
      listado_documento: "Llistat de documents",
      otro_tipo_documento: "Un altre tipus de document",
      nombre_documento: "Nom del document",
      url_documento: "URL del document",
      documentacion_privada: "Documentació privada",
      no_documentos:
        "No hi ha documents afegits, clica a afegir document per afegir-lo",
      documentacion_ligada: "Documentació lligada a processos",
      datos_profesionales: "Dades professionals",
      visitar: "Visitar",
      indica_link_perfil: "Indica link al teu perfil",
      trabajando_actualmente: "Treballant actualment",
      permiso_trabajo: "Permís de treball a la UE",
      anos_experiencia: "Anys d'experiència",
      sin_experiencia: "Sense experiència",
      disfrutado_erasmus:
        "He estat d'Erasmus o he gaudit d'una altra beca de mobilitat",
      minima_retribucion: "Mínima remuneració",
      brutos_anuales: "/ bruts anuals",
      datos_personales: "Dades personals",
      dni: "DNI",
      fecha_nacimiento: "Data de naixement",
      genero: "Gènere",
      femenino: "Femení",
      masculino: "Masculí",
      email_personal: "Email personal",
      email_estudiante: "Email d'estudiant",
      avisos_en_email: "Avisos a l'email personal",
      acepta_newsletter: "Accepta newsletter",
      idioma_comunicaciones: "Idioma preferent per a les comunicacions",
      movil: "Mòbil",
      fijo: "Telèfon fixe",
      direccion_empadronamiento: "Direcció d'empadronament",
      direccion_actual: "Direcció actual",
      direccion: "Direcció",
      iban: "Nº compte IBAN",
      seguridad_social: "Nº d'afiliació a la Seguretat social",
      pais_nacionalidad: "País de nacionalitat",
      pais_segunda_nacionalidad: "País de segona nacionalitat",
      provincia_nacimiento: "Província de naixement",
      provincia: "Província",
      lugar_nacimiento: "Lloc de naixement",
      discapacidad: "Discapacitat superior al 33%",
      deseo_recibir_comunicaciones:
        "Desitjo rebre comunicacions relacionades amb EUNCET i amb serveis relacionats amb formació superior. ",
      nombre: "Nom",
      primer_apellido: "Primer cognom",
      segundo_apellido: "Segon cognom",
      tipo_identificacion: "Tipus d'identificació",
      documento_identidad: "Document d'identitat",
      buscar: "Escriu per buscar",
      cp: "Codi Postal",
      pais: "País",
      localidad: "Localitat",
      tipo_via: "Tipus de via",
      numero: "Número",
      piso: "Pis",
      puerta: "Porta",
      notas: "Notes",
      datos_academicos: "Dades acadèmiques",
      formacion_complementaria: "Formació complementària",
      anadir_titulacion: "Afegir nova titulació",
      complementaria: "complementària",
      centro: "Centre",
      nivel_academico: "Nivell acadèmic",
      tipo: "Caràcter",
      nota: "Nota",
      rama_ensenanza: "Branca de la formació",
      duracion: "Durada",
      actual: "Actual",
      si: "Sí",
      no: "No",
      titulo: "Títol",
      universidad: "Universitat/Lloc d'estudis",
      centro_estudios: "Centre on vas cursar els estudis",
      calificacion: "Qualificació",
      calificacion_media: "Qualificació mitjana del títol",
      horas: "Hores",
      ambito: "Àmbit de l'ensenyament",
      selecciona_tipo: "- Selecciona un tipus -",
      certificacion: "Certificació",
      tienes_cerfificacion: "Tens certificació?",
      competencias_profesionales: "Competències professionals",
      tus_competencias: "Les teves competències",
      sin_competencias: "Sense competències professionals especificades",
      solicitar_sesion:
        "Necessites ajuda per omplir aquest apartat? Pots sol·licitar una sessió gratuïta d'orientació amb nosaltres punxant en aquest <a>enllaç</a> i t'ajudarem.",
      datos_interes: "Dades d'interès",
      busqueda_activa_practicas: "Recerca activa de pràctiques",
      busqueda_activa_empleo: "Recerca activa de treball",
      disponible_extranjero: "Disponibilitat per treballar a l'estranger",
      permiso_conducir: "Permís de conduir",
      disponible_cambio_residencia: "Disponible per a canvi de residència",
      coche_propio: "Cotxe propi",
      disponible_viajar: "Disponibilitat per viatjar",
      discapacidad_certificada: "Discapacitat certificada",
      carnet_moto: "Carnet de moto",
      moto_propia: "Moto pròpia",
      disponibilidad_jornadas: "Disponibilitat de jornades",
      periodo_preferencia_practicas: "Periode preferència pràctiques",
      selecciona: "Selecciona",
      anadir_idioma: "Afegir idioma",
      anadir_intereses: "Afegir interessos",
      nuevos_datos_academicos: "Noves dades acadèmiques",
    },
    addtitulacion: {
      titulo: "Titulacions a les quals s'adreça l'oferta",
      seleccione_areas: "Seleccioni àrees per filtrar titulacions",
      borrar_areas: "Esborrar totes les àrees",
      cualquier_area: "Qualsevol àrea",
      escriba_aqui:
        "Escriu aquí per filtrar el llistat de titulacions a continuació",
      selecciona_titulacion:
        "Seleccioni titulació/ns a la/es que s'adreça l'oferta fent clic a aquestes",
      ver_titulaciones: "Veure titulacions de grau",
      listadas: "llistades",
      listados: "llistats",
      cualquier_titulacion: "Qualsevol d'aquestes titulacions de grau",
      ver_titulaciones_postgrado: "Veure titulacions de postgrau",
      cualquier_titulacion_postgrado:
        "Qualsevol d'aquestes titulacions de postgrau",
      ver_titulaciones_propio: "Veure titulacions de títol propi",
      cualquier_titulacion_propio: "Qualsevol d'aquests títols propis",
      lo_sentimos:
        "Ho sentim no s'han trobat titulacions que coincideixin amb la recerca",
      listado_titulaciones_seleccionadas:
        "Llistat de titulacions seleccionades",
      eliminar_titulaciones: "Eliminar totes les titulacions seleccionades",
    },
    candidato: {
      nuevo: "Nou",
      pendiente_form_incorporacion: "Pendent formulari incorporació",
      cambiar_estado: "Canviar estat",
      ver_cv: "Veure CV",
      detalles: "Detalls del candidat/a",
      selecciona_estado: "Selecciona un estat",
      seleccione_motivo:
        "Si us plau seleccioni el motiu de rebuig del candidat/a.",
      cambio_estado: "Canvi d'estat",
      descargar_cv: "Descarregar CV",
      cumplimentar_formulario_incorporacion: "Omplir formulari d'incorporació",
    },
    cambio_practicas: {
      identifica:
        "Identifica l'estudiant que sol·licita realitzar pròrroga o variació de les seves condicions de pràctiques.",
      alumno: "Estudiant",
      selecciona_oferta: "Selecciona l'oferta",
      no_practicas:
        "Encara no tens cap pràctica sobre la qual puguis demanar un canvi.",
      alumno: "Estudiant",
      selecciona_alumno: "Selecciona l'estudiant",
      detalles: "Detalls de la modificació",
      tipo_modificacion: "Tipus de modificació",
      selecciona_modificacion: "-Selecciona la modificació-",
      otros_detalles: "Altres detalls",
      adjunto: "Adjunt",
      solicitar_cambio: "Sol·licitar canvi",
    },
    popup_idioma: {
      titulo: "Canviaràs la teva preferència d'idioma. Vols continuar?",
    },
    formulario_incorporacion: {
      formularioYaCumplimentado:
        "Aquest formulari d' incorporació ja ha estat omplert. Aquest procés requereix la validació per part d'un gestor d' EUNCET.",
      encabezado:
        "Omple el formulari d' incorporació per completar la candidatura de l'estudiant i enviar-la a la persona seleccionada.",
      persona_de_contacto: "Persona de contacte",
      contacto_nombre: "Nom",
      contacto_apellidos: "Cognoms",
      contacto_cargo_departamento: "Càrrec/Departament",
      contacto_email: "E-mail",
      contacto_num_telefono: "Nº de Telèfon",
      persona_firmante_anexo_convenio: "Persona signant de l'annex",
      persona_firmante_convenio_empresa:
        "Persona signant del conveni de cooperació educativa",
      firmante_nombre: "Nom",
      firmante_apellidos: "Cognoms",
      firmante_cargo_departamento: "Càrrec del signant",
      firmante_email: "E-mail",
      firmante_telefono: "Telèfon",
      datos_alumno: "Dades de l'estudiant",
      alumno_dni: "DNI",
      alumno_nombre_apellidos: "Nom i cognoms",
      alumno_titulacion: "Titulació",
      fecha_inicio: "Data d'inici",
      fecha_fin: "Data de fi",
      datos_periodo_practicas: "Dades sobre el període de pràctiques",
      lugar_realizacion_practicas: "Lloc de realització de les pràctiques",
      datos_tutor_empresa: "Dades del tutor o tutora a l'empresa",
      tutor_nombre: "Nom",
      tutor_apellidos: "Cognoms",
      tutor_cargo: "Càrrec a l'empresa",
      tutor_email: "E-mail",
      tutor_dni: "DNI",
      tutor_telefono: "Telèfon",
      horario: "Horari",
      num_horas_dia: "Número d'hores al dia",
      num_horas_semana: "Número d'hores per setmana",
      horas_semana: "Hores setmanals",
      retribucion_euros_hora: "Retribució € bruts/hora",
      otras_remuneraciones: "Altres remuneracions",
      descripcion_actividad:
        "Descripció detallada de l'activitat a realitzar per l'estudiant (imprescindible per valorar i aprovar la seva preferència)",
      datos_facturacion: "Dades de facturació",
      info_datos_facturacion:
        "Si és necessari número de comanda o número d'ordre de compra per a la gestió de la factura en concepte de 'despeses de gestió del conveni' de 90€+IVA que emetrà Euncet, si us plau, indiqui a continuació el número",
      num_pedido: "Número de comanda",
      comp_genericas:
        "Competències genèriques que l'estudiant treballarà durant les pràctiques",
      compEspecificas: "Competències específiques",
      formaPrevistaSeguimientoOrientacion:
        "Forma prevista de Seguiment i Orientació",
      seguimientoDiario: "Seguiment diari",
      reunionesSemanales: "Reunions setmanals",
      reunionesPeriodicas: "Reunions periòdiques",
      seguridadSalud:
        "Seguretat i salut durant la realització de les pràctiques",
      seguridadSalud_informado:
        "Se l'ha informat sobre els aspectes de seguretat i salut que haurà de seguir a l'empresa durant la realització de les pràctiques (entrega del document d'identificació de riscos i mesures preventives del seu lloc)",
      seguridadSalud_entregado:
        "Se li han lliurat els equips de protecció individual (només en cas de ser necessaris)",
      otros: "Altres (Especificar)",
      formacionAdquirida: "Formació que adquirirà l'estudiant",
      actividadesTareas: "Activitats i tasques que ha de desenvolupar l'estudiant",
      lenguaInglesa: "Llengua Anglesa",
      lenguaInglesa_texto: "Comunicar-se en anglès amb un nivell adequat dexpressió oral i escrita dacord amb làmbit dintervenció professional",
      comunicacion: "Comunicació", 
      comunicacion_texto: "Comunicar-se oralment i per escrit amb destresa i fluïdesa a la llengua de l'entorn professional",
      trabajoEquipo: "Treball en equip",
      trabajoEquipo_texto: "Treballar en equip a diferents nivells i amb diferents professionals i institucions relacionades amb el context empresarial",
      direccionPersonas: "Direcció de persones",
      direccionPersonas_texto: "Dirigir persones i equips professionals",
      investigacion: "Investigació i gestió de la informació", 
      investigacion_texto: "Buscar i gestionar informació empresarial i valorar de manera crítica els resultats obtinguts",
      aprendizajeAutonomo: "Aprenentatge autònom",
      aprendizajeAutonomo_texto: "Aprendre de manera autònoma",
      autoconocimiento: "Autoconeixement",
      autoconocimiento_texto: "Detectar limitacions i mancances en els propis coneixements i competències professionals i ser capaç de superar-les",
      planificacion: "Planificació i organització",
      planificacion_texto: "Planificar i organitzar tasques per assolir els objectius en els terminis establerts",
      orientacion: "Orientació a l'èxit",
      orientacion_texto: "Identificar problemes, obstacles i oportunitats i saber proposar millores i trobar noves estratègies o solucions",
      empatia: "Empatia i habilitats socials",
      empatia_texto: "Percebre i comprendre les situacions socials de les persones que l'envolten",
      flexibilidad: "Flexibilitat",
      flexibilidad_texto: "Adaptar-se a situacions i persones en contextos daprenentatge i professionals",
      pensamientoAnalitico: "Pensament analític",
      pensamientoAnalitico_texto: "Identificar i valorar les situacions i problemes, separant-ne i organitzant-ne les parts integrants, i reflexionar-hi d'una manera lògica i sistemàtica"
    },
    popup_aceptaSS: {
      info: "Informació sobre la Seguretat Social",
      remunerada:
        "A partir de l'1 de gener de 2024, tal com estableix el Reial Decret-Llei 2/2023 (article únic ap.34), quedaran <strong>inclosos en el sistema de Seguretat Social</strong> tots els estudiants que realitzin pràctiques acadèmiques externes, <strong>tant pràctiques remunerades com pràctiques no remunerades.</strong></br></br>El compliment de les obligacions de Seguretat Social correspondrà sempre a l' empresa, institució o entitat en la qual es desenvolupen les pràctiques, que assumirà a aquests efectes la condició d' empresari; excepte casos excepcionals en què s' hagi acordat prèviament que se' n farà càrrec Euncet i que s' hagi indicat expressament i signat en el conveni de cooperació educativa.",
      no_remunerada:
        "A partir de l'1 de gener de 2024, tal com estableix el Reial decret llei 2/2023 (article únic ap.34). En el cas de les pràctiques formatives no remunerades, el compliment de les obligacions de Seguretat Social correspondrà a l'empresa, institució o entitat en la qual es desenvolupin aquells, dret que en el conveni o acord de cooperació que, si és el cas, se subscrigui per a la seva realització es disposi que tals obligacions correspondran al centre de formació responsable de l'oferta formativa.",
      entendido:
        "He llegit i entenc les obligacions en matèria de Seguretat Social",
      aceptar: "Acceptar",
    },
    politica_privacidad: {
      informacion_usuario: "1. INFORMACIÓ A l'USUARI",
      responsable_tratamiento:
        "Qui és el responsable del tractament de les teves dades personals?",
      responsable_tratamiento_text:
        "<b>EUNCET FORMACIÓ SL</b> és el RESPONSABLE del tractament de les dades personals de l'USUARI i l'informa que aquestes dades seran tractades de conformitat amb el que es disposa en el Reglament (UE) 2016/679, de 27 d'abril (RGPD), i la Llei orgànica 3/2018, de 5 de desembre (LOPDGDD).",
      para_que_tratamos: "Per a què tractem les teves dades personals?",
      para_que_tratamos_text1:
        "Les dades personals recollides seran tractades pel RESPONSABLE per a les següents finalitats",
      para_que_tratamos_text2:
        "Remissió de comunicacions comercials publicitàries per e-mail, fax, SMS, MMS, xarxes socials o qualsevol altre mitjà electrònic o físic, present o futur, que possibiliti realitzar comunicacions comercials. Aquestes comunicacions seran realitzades pel RESPONSABLE i estaran relacionades amb els seus productes i serveis, o dels seus col·laboradors o proveïdors, amb els quals aquest hagi aconseguit algun acord de promoció. En aquest cas, els tercers mai tindran accés a les dades personals.",
      para_que_tratamos_text3:
        "Realitzar estudis de mercat i anàlisis estadistics.",
      para_que_tratamos_text4:
        "Tramitar encàrrecs, sol·licituds, donar resposta a les consultes o qualsevol tipus de petició que sigui realitzada per l'USUARI a través de qualsevol de les formes de contacte que es posen a la seva disposició a la pàgina web del RESPONSABLE",
      para_que_tratamos_text5:
        "Remetre el butlletí informatiu online sobre novetats, ofertes i promocions RESPONSABLE.",
      para_que_tratamos_text6: "Tractaments derivats de l' activitat docent.",
      para_que_tratamos_text7:
        "Tramesa, recepció de CV i ompliment de formularis per la gestió de processos de selecció de personal que es trobin habilitats o puguin habilitar-se per part del RESPONSABLE o per tercers a través de la plataforma establerta a tal fi.",
      para_que_tratamos_text8:
        "Gestió de Canal de Denúncies. El RESPONSABLE disposa d'un canal de denúncies que assegura el dret de les persones a informar d'incidents, mala conducta i altres comportaments substancialment incorrectes. Tal com preveu la normativa vigent, aquestes denúncies poden ser anònimes. En cas que la persona denunciant s'identifiqui, tractarem les seves dades amb l'única fi de tramitar la denúncia i elaborar l'informe corresponent. En cap cas es farà ús d'aquestes dades per a fins diferents a la gestió de la denúncia i es conservaran només el temps necessari per a dur a terme la finalitat o fins que existeixi l'obligació legal de conservar-les.",
      para_que_tratamos_text9:
        "Mantenir una relació entre els usuaris i el RESPONSABLE a través de les seves xarxes socials que pot incloure les següents operacions",
      para_que_tratamos_text10: "Tramitar sol·licituds i consultes.",
      para_que_tratamos_text11:
        "Informar sobre activitats i esdeveniments organitzats pel responsable.",
      para_que_tratamos_text12:
        "Informar sobre productes o serveis oferts pel RESPONSABLE.",
      para_que_tratamos_text13: "Interactuar a través dels perfils oficials.",
      por_que_tratamos:
        "Per quin motiu podem tractar les teves dades personals?",
      por_que_tratamos_text1:
        "Perquè el tractament està legitimat per l'article 6 del RGPD de la següent forma",
      por_que_tratamos_text2: "Amb el consentiment de l'USUARI",
      por_que_tratamos_text3:
        "Remissió de comunicacions comercials i del butlletí informatiu.",
      por_que_tratamos_text4: "Gestió dels processos de selecció de personal.",
      por_que_tratamos_text5:
        "Mantenir una relació amb el RESPOSABLE a través de les seves xarxes socials. Si l'usuari disposa d'un perfil en la mateixa xarxa social i ha decidit unir-se a la xarxa social del RESPOSABLE, ha mostrat un interès en la informació que es publiqui i, per tant, a l'hora de sol·licitar seguir els nostres perfils oficials, ens facilita el consentiment per al tractament de les dades personals publicades en el seu perfil.",
      por_que_tratamos_text6:
        "Pot accedir en qualsevol moment a les polítiques de privacitat de la pròpia xarxa social, i configurar el seu perfil per a garantir la seva privacitat. El RESPONSABLE té accés i tracta la informació seva pública, especialment, el seu nom de contacte.",
      por_que_tratamos_text7:
        "Per interès legítim del RESPONSABLE realitzar estudis de mercat, anàlisis estadístiques, tractaments derivats de l'activitat docent i tramitar encàrrecs, sol·licituds, etc. a petició de l'USUARI.",
      por_que_tratamos_text8:
        "Per obligació legal de gestió del canal de denúncies.",
      por_que_tratamos_text9:
        "Per ser necessari en l'execució d'un contracte prestació de serveis i els tractaments derivats de l'activitat docent.",
      durante_cuanto_tiempo_tratamos:
        "Durant quant temps guardarem les teves dades personals?",
      durante_cuanto_tiempo_tratamos_text1:
        "Es conservaran durant no més del temps necessari per a mantenir la fi del tractament o existeixin prescripcions legals que dictaminin la seva custòdia i quan ja no sigui necessari per a això, se suprimiran amb mesures de seguretat adequades per a garantir l'anonimització de les dades o la destrucció total d'aquests.",
      a_quien_facilitamos: "A qui facilitem les teves dades personals?",
      a_quien_facilitamos_text1:
        "No està prevista cap comunicació de dades personals a tercers excepte, si fos necessari per al desenvolupament i execució de les finalitats del tractament, als nostres proveïdors de serveis relacionats amb comunicacions, amb els quals el RESPONSABLE té subscrits els contractes de confidencialitat i d'encarregat de tractament exigits per la normativa vigent de privacitat o existeixi obligació legal.",
      a_quien_facilitamos_text2:
        "Les dades facilitades per omplir els formularis per a la inscripció en els processos de selecció de personal, podran ser comunicats a diferents empreses oferents de pràctiques i/o ocupació, amb la finalitat d'estudiar la seva sol·licitud, i si és el cas, el començament del procés de selecció, així com el manteniment del perfil del candidat (possible enviament de comunicats, confirmació d'inscripció a ofertes, canvis d'estat en les candidatures, entre altres) i dur a terme la gestió de possibles sol·licituds d'ocupació.",
      cuales_son_tus_derechos: "Quins són els teus drets?",
      cuales_son_tus_derechos_text1: "Els drets que afecten a l'USUARI són",
      cuales_son_tus_derechos_text2:
        "Dret a retirar el consentiment en qualsevol moment.",
      cuales_son_tus_derechos_text3:
        "Dret d'accés, rectificació, portabilitat i supressió de les seves dades, i de limitació o oposició al seu tractament.",
      cuales_son_tus_derechos_text4:
        "Dret a presentar una reclamació davant l'autoritat de control (www.aepd.es) si considera que el tractament no s'ajusta a la normativa vigent.",
      datos_contacto_derechos: "Dades de contacte per exercir els seus drets",
      datos_contacto_derechos_text1:
        "EUNCET FORMACIÓN SL. Camí del Mas Rubial, núm. 1 - 08225 Terrassa (Barcelona). E-mail datos@euncet.com",
      datos_contacto_derechos_text2:
        "Dades de contacte del delegat de protecció de dades info@badia-adv.com,",
      caracter_obligatorio_o_facultativo:
        "2. CARÀCTER OBLIGATORI O FACULTATIU DE LA INFORMACIÓ FACILITADA PER l'USUARI",
      caracter_obligatorio_o_facultativo_text1:
        "l'USUARI, mitjançant la marcació de les caselles corresponents i l'entrada de dades en els camps obligatòris, accepta expressament i de manera lliure i inequívoca, que les seves dades són necessàries per a atendre la seva petició. El RESPONSABLE indicarà quines dades són necessaris per a la prestació d'un servei òptim a l'USUARI. En cas que no es facilitin aquestes dades, no es garanteix que la informació i serveis facilitats siguin completament ajustats a les seves necessitats. l'USUARI garanteix que les dades personals facilitades al RESPONSABLE són veraços i es fa responsable de comunicar qualsevol modificació d'aquests.",
      medidas_de_seguridad: "3. MESURES DE SEGURETAT",
      medidas_de_seguridad_text1:
        "Que de conformitat amb el que es disposa en les normatives vigents en protecció de dades personals, el RESPONSABLE està complint amb totes les disposicions de les normatives RGPD i LOPDGDD per al tractament de les dades personals de la seva responsabilitat, i manifestament amb els principis descrits en l'article 5 del RGPD, pels quals són tractats de manera lícita, lleial i transparent en relació amb l'interessat i adequats, pertinents i limitats al necessari en relació amb els fins per als quals són tractats.",
      medidas_de_seguridad_text2:
        "El RESPONSABLE garanteix que ha implementat polítiques tècniques i organitzatives apropiades per aplicar les mesures de seguretat que estableixen el RGPD i la LOPDGDD per tal de protegir els drets i llibertats dels USUARIS i els ha comunicat la informació adequada perquè puguin exercir-los.",
      medidas_de_seguridad_text3:
        "Per a més informació sobre les garanties de privacitat, pots adreçar-te al RESPONSABLE a través d'EUNCET FORMACIÓN SL. Camí del Mas Rubial, núm. 1 - 08225 Terrassa (Barcelona). E-mail datos@euncet.com",
      medidas_de_seguridad_text4:
        "Dades de contacte del delegat de protecció de dades info@badia-adv.com",
    },
    footer: {
      campus: [
        {
          title: "CAMPUS BARCELONA CAN DRAGÓ",
          subtitle: "Nou Barris · Parc Can Dragó",
          direction: "C/ de Rosselló i Pòrcel, 7, 11 A, 08016, Barcelona",
          tel: "937 30 17 43",
        },
        {
          title: "CAMPUS BARCELONA 22@",
          subtitle: "Sant Martí",
          direction: "C/ de Badajoz, 145, Sant Martí, 08018 Barcelona",
          tel: "930 33 33 30",
        },
        {
          title: "CAMPUS TERRASSA",
          subtitle: "Parc de Sant Llorenç del Munt i l'Obac",
          direction: "C/ Camí del Mas Rubial, 1, 08225, Terrassa",
          tel: "935 47 60 66",
        },
      ],
    },
    propuesta_practicas: {
      cabecera_empresas: "Si un alumne/a realitzarà pràctiques a la vostra empresa, podeu donar d'alta aquí tots els detalls. Valorarem i formalitzarem la seva proposta si, tant les pràctiques oferides com el candidat/a seleccionat/da, compleixen els requisits exigits.",
      datos_alumno: "Dades de l'alumne/a",
      introduce_dni: "Introdueix el DNI de candidat/a.",
      dni: "DNI/NIE/Passaport",
      validar_candidato: "Validar candidat/a",
      comprueba_datos: "Comproveu que les dades del candidat/a coincideixen. Si tens dubtes, o hi ha algun error escriu-nos a",
      nombre: "Nom del candidat/a",
      selecciona_titulacion: "Selecciona una titulació",
      list_selecciona_titulacion: "Fes clic per seleccionar una titulació",
      titulacion_candidato: "Titulació del candidat/a",
      cabecera_alumno: "Si has trobat una empresa on realitzar les teves pràctiques acadèmiques curriculars o extracurriculars, la pots donar d'alta aquí. La valorarem i assignarem si compleix tots els requisits exigits.",
      desconocido: "Si desconeixes alguna dada si us plau indica'ns desconeguda",
      datos_academicos: "Dades acadèmiques",
      paso_1: "Pas 1 de 4",
      paso_2: "Pas 2 de 4",
      paso_3: "Pas 3 de 4",
      tipo_propuesta: "Quin tipus de pràctica sol·licitar/proposaràs?",
      curricular: "Curricular",
      extracurricular: "Extracurricular",
      datos_empresa: "Dades de l'empresa",
      introduce_cif: "Introdueix el CIF de l'empresa, on realitzaràs les practiques.",
      cif_o_nif: "CIF (empresa) o NIF (autònom)",
      validar_empresa: "Validar empresa",
      comprueba_datos_alumno: "Comproveu que les dades de l'empresa coincideixen amb les dades de l'empresa on realitzareu les pràctiques. En cas de tenir un dubte, o haver-hi algun error escriu-nos a",
      nombre_empresa: "Nom de l'empresa",
      cif_empresa: "Cif de l'empresa",
      datos_contacto: "Dades del contacte de lempresa",
      introduce_email_contacto: "Introdueix el correu electrònic del teu contacte a l'empresa.", 
      validar_contacto: "Validar contacte",
      comprueba_datos_contacto: "Comproveu que les dades de l'empresa coincideixen amb les dades del contacte. En cas de tenir un dubte, o haver-hi algun error escriu-nos a",
      nombre_contacto: "Nom del contacte",
      email_contacto: "Email del contacte",
      no_existe_cif: "El CIF proporcionat no existeix a la nostra base de dades, si us plau omple els següents camps.",
      datos_firmante: "A continuació introduïu les dades del representant legal de l'empresa que signarà els convenis:",
      no_exite_contacto: "No tenim dades a la nostra base de dades del teu contacte, si us plau omple les dades.",
    }
  },
  en: {
    guardar: "Save",
    volver: "< Back",
    sin_definir: "Undefined",
    guardar_datos: "Save data",
    cancelar: "Cancel",
    confirmar: "Confirm",
    eliminar: "Eliminate",
    aceptar: "Accept",
    rechazar: "Reject",
    comenzar: "Begin",
    cerrar_sesion: "Log out",
    ver_menos: "Show less",
    ver_mas: "See more",
    inicio: "Beginning",
    ver_detalles: "View Details",
    guardar: "Save",
    editar: "Edit",
    anadir: "Add",
    enviar: "Send",
    requerido: "Required",
    revisar: "Revise",
    editar_oferta: "Edit Offer",
    duplicar_oferta: "Duplicate offer",
    cerrar_oferta: "Close Deal",
    eliminar_oferta: "Eliminate offer",
    ver_como_candidato: "View as a candidate",
    practicas: "Internship",
    empleo: "Employment",
    ver: "See",
    enlaces: {
      politica_privacidad: "/politica-de-privacidad",
      politica_cookies: "/politica-de-cookies",
      login: "/login",
      solicitar_cuenta: "/solicitar-cuenta",
      registroalumno: "/registroalumno",
      encuestas: "/encuestas",
      encuesta: "/encuesta",
      eventos: "/eventos",
      eventospublico: "/evento-publico",
      documentacion: "/documentacion",
      guiaOrientacion: "/guias-orientacion",
      ofertas_practicas: "/ofertas-practicas",
      ofertas_empleo: "/ofertas-empleo",
      cv: "/cv",
      vercv: "/ver-cv",
      mis_candidaturas: "/mis-candidaturas",
      mis_practicas: "/mis-practicas",
      orientacion: "/orientacion-laboral",
      propuesta_practicas: "/propuesta-practicas",
      programapracticasactivos: "/programas-practicas-activos",
      solicitarcambiopracticas: "/solicitar-cambio-practicas",
      subirconvenio: "/subir-convenio-firmado",
      generarnuevoconvenio: "/nuevo-convenio-colaboracion",
      practicaseducacion: "/solicitudes-practicas-educacion",
      nueva_oferta: "/nueva-oferta",
      editar_oferta: "/editar-oferta",
      mi_empresa: "/mi-empresa",
      mi_perfil: "/mi-perfil",
      mis_ofertas: "/mis-ofertas",
      mi_oferta: "/oferta",
      programa_practicas: "/programa-practicas",
      visualizar_oferta: "/visualizar-oferta",
      restablecer_login: "/restablecer-login",
      restablecer_candidato: "/restablecer-candidato",
      setear_pass: "/establecer-login",
      proteccion_datos: "/proteccion-de-datos",
      acceso_saml: "/acceso",
      logout: "/logout",
      ayuda: "/ayuda",
      condicionespracticasuib: "/EUNCET/condiciones-practicas",
      formulario_datos: "/formulario-datos",
    },
    encabezado: {
      home: "Employment and Internship Portal",
      cv: "My CV",
      cv_view: "Candidate's CV",
      eventos: "Events",
      propuesta_practicas: "Internship proposal",
      politica_privacidad: "Privacy Policy",
      politica_cookies: "Cookies policy",
      login: "Login",
      solicitar_cuenta: "New Company",
      registro_alumno: "Registration",
      ofertas_practicas: "List of internship offers",
      ofertas_empleo: "List of job offers",
      ficha_oferta_alumno_empleo: "List of job offers",
      ficha_oferta_alumno_practicas: "List of internship offers",
      mis_candidaturas: "My Applications",
      mis_practicas: "My internship",
      encuestas: "Surveys",
      orientacion: "Career guidance",
      nueva_oferta: "New offer",
      editar_oferta: "Edit Offer",
      mi_empresa: "My Company",
      mi_perfil: "My profile",
      documentacion: "Documentation",
      guiasOrientacion: "Orientation Guides",
      documentacion_empresa: "Documentation",
      documentacion_alumno: "My documentation",
      mis_ofertas: "My offers",
      mi_oferta: "My offer",
      ficha_oferta_empresa: "My offer",
      restablecer_login: "Reset Password",
      restablecer_candidato: "Reset Password",
      programapracticasactivos: "Active Internship Programs",
      setear_pass: "Set Password",
      proteccion_datos: "Data protection",
      visor_oferta: "View as a student",
      fichaProgramaActivo: "Active Programs",
      solicitudCambioPracticas: "Application for change of internship",
      solicitudesEducacion: "Applications for education offers",
      subirConvenioFirmado: "Upload signed agreement",
      generarNuevoConvenio: "New Collaboration Agreement",
      ayuda: "Help",
      condicionespracticasuib: "Internship conditions",
      info_alumno:
        "Remember that if you want to do an internship until 15 September, do not apply for the certificate until after that date. If you apply for the certificate before 15 September, you will lose your student status and will no longer be able to do an internship.",
      formulario_datos: "Data form",
      formulario_incorporacion: "Incorporation form",
      falta_num_ss:
        "Due to the entry into force of the new Royal Decree-Law 2/2023, of March 16, which came into force on January 1, 2024, it is MANDATORY that you provide us with your Social Security affiliation number. Access your profile to fill in this information.",
    },
    ficha_oferta: {
      texto_programa_anadido:
        "You have this program added to your list of computer programs",
    },
    formulario: {
      nombre: "Name",
      nombre_apellidos: "Name and surname",
      apellidos: "Surnames",
      email: "Email",
      mensaje: "Message",
      fecha_nacimiento: "Date of birth",
      dia: "Day",
      mes: "Month",
      anyo: "Year",
      area_interes: "Area of your interest",
      trabaja_actualmente: "Are you currently working?",
      si: "Yes",
      no: "No",
      carta_presentacion: "Cover letter",
      meses: {
        Enero: "January",
        Febrero: "February",
        Marzo: "March",
        Abril: "April",
        Mayo: "May",
        Junio: "June",
        Julio: "July",
        Agosto: "August",
        Septiembre: "September",
        Octubre: "October",
        Noviembre: "November",
        Diciembre: "December",
      },
      archivo_adjunto: "Attach File",
      adjuntar_cv: "Attach CV",
      introduce_mail: "Enter your email",
      pais: "Country",
      telefono: "Telephone",
      he_leido: "I have read and accept the",
      y_acepto: "Privacy Policy",
      enviar: "Send",
      enviado: "Sent",
    },
    meses: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    login: {
      iniciar_sesion: "LOGIN",
      acceder: "Enter",
      email: "Email",
      error_mail:
        "Please enter the same email address that appears on your Euncet Campus login to access the portal.",
      contrasena: "Password",
      repetir_contrasena: "Repeat Password",
      contrasena_olvidada: "Generate/recover password",
      introduce_email: "Enter your email",
      email_mal: "",
      recuperar_pass: "Recover my password",
      aun_no_registrado: "Not registered yet?",
      acceder_SSO: "",
      indica_mail: "",
      selecciona_empresa: "Please select the company you want to access.",
      titulacion: "Degree",
      tipo_formacion: "Type of academic training",
      selecciona_formacion: "Select a training type",
      registrarme: "Register",
      deseo_recibir:
        "I would like to receive communications related to EUNCET and higher education related services.",
      popup_rgpd: {
        titulo: "MORE INFORMATION",
        detalle:
          "If you need more detailed information, you can access the Data Protection Policy at ",
        enlace: "link.",
        boton: "Consent, access",
      },
      restablecer_pass: {
        titulo: "Follow the steps to reset your password",
        intro: "The password must contain at least 8 characters and a number.",
        guardar: "Save",
      },
      seteo_pass: {
        titulo: "Follow the steps to set your password",
        intro: "The password must contain at least 8 characters and a number.",
        guardar: "Save",
      },
    },
    registro: {
      encabezado: "Fill in the form below to register in the system.",
      datos_usuario: "Company User Data",
      datos_personales: "Personal data",
      nombre: "Name",
      apellidos: "Surnames",
      DNI: "DNI/NIF/NIE",
      CIF: "Company VAT number",
      puesto: "Position / Position",
      departamento: "Department",
      telefono_1: "Phone 1",
      telefono_2: "Phone 2",
      email: "Email",
      sede: "Default Headquarters",
      cargo: "Position",
      idioma: "Favourite language of communication",
      tipo_contacto: "Contact Type",
      contrasena: "Password",
      repetir_contrasena: "Repeat Password",
      direccion: "Address",
      pais: "Country",
      selecciona_pais: "-Select a country-",
      provincia: "Province",
      selecciona_provincia: "-Select a province-",
      localidad: "Locality",
      selecciona_localidad: "-Select a location-",
      direccion: "Address",
      direccion_empresa: "Company Address",
      cp: "Zip code",
      titulo_2:
        "Please enter your company details below to register in the system.",
      anadir_imagen: "Click to add image",
      autorizar_logo: "Authorize use of the logo",
      nombre_fiscal: "Fiscal name or company name",
      email_empresa: "Company email",
      cp: "Postal code",
      nombre_comercial: "Trade name",
      tipo_sociedad: "Type of Company",
      selecciona_tipo_sociedad: "-Select type of company-",
      tipo_empresa: "Type of Company",
      privada: "Private",
      publica: "Public",
      startup: "Startup",
      eliminar: "Eliminate",
      descripcion: "Description",
      si: "Yes",
      no: "No",
      sector: "Sector",
      selecciona_sector: "-Select a sector-",
      otro_sector: "Other Sector",
      numero_empleados: "Number of employees",
      selecciona_empleados: "-Select a range-",
      web: "Web",
      iban: "IBAN account number",
      descripcion_empresa: "Company Description",
      femenino: "Female",
      masculino: "Male",
      telefono: "Telephone",
      firmante: {
        titulo:
          "Next enter the data of the person acting as legal representative of the company who will sign the agreements.",
        no_obligatorio: "(not obligatory, can be indicated later)",
        nombre: "Signatory's Name",
        apellidos: "Signatory's Last Name",
        email: "Signatory Email",
        dni: "DNI of signatory",
        cargo: "Signatory's Position",
        telefono: "Telephone",
      },
      contacto: {
        nombre: "Contact Name",
        apellidos: "Contact Last Name",
        email: "Contact Email",
        telefono: "Telephone",
      },
      envio_facturas: {
        titulo: "Invoice forwarding address",
        titulo_2: "Invoicing address",
      },
      anadir_direccion: "Add a new invoice address",
      perfil_sectorial: "Sector profile",
      sector_actividad: "Sector of activity",
      selecciona_sector_actividad: "-Select a sector-",
      rango: "Billing range",
      selecciona_rango: "-Select a range-",
      numero_empleados: "Number of employees",
      selecciona_numero_empleados: "-Select a range-",
      anyo_fundacion: "Year Founded",
      politica_1: "I have read and accept the,",
      politica_2: "Privacy Policy",
      nuevo_contacto_titulo: "Details of the new management contact",
      anadir_contacto: "Add contact",
      nueva_cuenta_fiscal: "New tax account data",
      domicilio_fiscal: "Tax Domicile",
      poblacion: "Population",
      requiere_envio_postal: "Requires postal delivery of invoices",
      domicilio_postal: "Address for postal delivery of invoices",
      anadir_cuenta: "Add Account",
      datos_firmante: "Signatory details",
      area_conocimiento: "Area or branch of knowledge",
      nombre_titulacion: "Name of the degree",
      ano_inicio: "Year of Inception",
      ano_finalizacion: "Year of completion",
      solicitar_cuenta: "Request Account",
      seguir_empresa: "Continue with company data",
      registrar_empresa: "Register Company",
      dni_pasaporte_nie: "DNI/NIF/NIE/Passport",
      selecciona_nivel: "-Select a level-",
      busca_area: "Search the area",
      busca_titulacion: "Search for the degree",
      firmaDigital: "Type of signature for the agreement ",
      asume_coste_SS:
        "¿Su entidad acepta asumir el cumplimiento, gestión y coste de las obligaciones en materia de Seguridad Social de los estudiantes que realicen prácticas formativas o prácticas académicas externas en su institución, tal y como recoge el Real Decreto-ley 2/2023?",
      asume_coste_SS_Si:
        "Si, aceptamos asumir el cumplimiento, gestión y coste de las obligaciones de la Seguridad Social del estudiante, en el momento que sea de aplicación efectiva tal y como recoge el Real Decreto-ley 2/2023.",
      asume_coste_SS_No:
        "No Aceptamos. Solicitamos que sea EUNCET, la entidad que asuma el cumplimiento, gestión y coste de las obligaciones de la Seguridad Social del estudiante, en el momento que sea de aplicación efectiva tal y como recoge el Real Decreto-ley 2/2023.",
    },
    home_empresa: {
      ofertas_practicas: "OFFERS<strong>Internship</strong> ",
      texto_ofertas_practicas:
        "Enquiry and manage internship offers and applications received.",
      nueva_practicas: "PUBLISH<strong>New internship offer",
      publicar_practicas:
        "It publishes internship offers, aimed to our students.",
      nueva_propuesta: "REQUEST INTERNSHIP<strong>Internship proposal",
      publicar_propuesta:
        "If you have already selected the person who will perform the internship, make your internship proposal for this student here.",
      ofertas_empleo: "OFFERS<strong>Job offers",
      texto_ofertas_empleo:
        "Enquiry and manage job offers and applications received.",
      nueva_empleo: "POST<strong>New job offer",
      texto_nueva_empleo: "Publish job offers",
    },
    mi_practica: {
      subir_documentacion: "Upload documentation",
      descargar_anexo: "Download Signed Annex",
      descargar_certificado: "Download internship certificate",
      descargar_poliza: "",
      titulo_practicas:
        "In order to be able to join the development of these internships it is necessary",
      pagar_creditos: "Pay the credits that are going to be recognized.",
      descarga: "Download",
      aqui: "here",
      documento_pago: "",
      contratar_poliza: "",
      puedes_contratar: "",
      mensaje_documentos: "",
      digitaliza_documentos: "",
      adjuntar_pago: "Attach proof of payment",
      adjuntar_seguro: "Attach insurance policy",
      descarga_ficheros:
        "Download the following files, sign them and attach them again.",
      enviar: "Send",
      renuncia_practicas_SET:
        "These extracurricular internships will be part of your SET (European Diploma Supplement) if you meet the legal requirements, in case you do not want them to join SET, you must attach a signed resignation document. You can download the document template",
      adjuntar_renuncia: "Attach signed waiver",
    },
    mis_practicas: {
      titulo:
        "In this section you will find all the documentation regarding your internship.",
      zero_1: "There is no internhsip or internship documentation to show.",
    },
    cambio_password: {
      titulo: "Change password",
      titulo_candidato: "Want to change your password?",
      contrasena_actual: "Current password",
      nueva_contrasena: "New Password",
      repetir_contrasena: "Repeat New Password",
    },
    guia_orientacion: {
      titulo:
        "Below you will find documents related to your internship or employment, tips and best practices that may be of interest to you.",
      zero: "No orientation guides",
    },
    mi_empresa: {
      intro: {
        cuerpo:
          "The main details of your company are shown below. If any of them are not correct, or if you need to access, correct, or delete any details of your information, please send an e-mail to careers.services@euncet.com.",
        porfavor: "If you have any questions, please ",
        contacte: "Contact us.",
      },
      datos_empresa: "Company Data",
    },
    formulario_datos: {
      intro: {
        cuerpo:
          "The main details of your company are shown below. Please update or fill in the following information about your company.",
        porfavor: "Please ",
        contacte: "Contact us.",
      },
      datos_empresa: "Company Data",
      datos_firmante: "Signatory details",
      datos_contacto: "Contact details",
    },
    candidaturas_options: {
      aceptar: "Accept Enrollment",
      rechazar: "Decline Enrollment",
      motivos_rechazo: "Reasons for rejection",
      selecciona_motivo: "- Select a rejection reason -",
      rechazar_preinscripcion: "Decline to pre-register for the offer",
    },
    oferta: {
      intro_editor: "To create a new offer you must fill in the form below.",
      tipo_oferta: "Offer Type",
      numero_plazas: "Number of places",
      experiencia: "Experience",
      experiencia_deseable: "Desirable experience",
      horario: "Schedule",
      fecha_inicio: "Start Date",
      fecha_fin: "End Date",
      tipo_contrato: "Type of contract",
      salario: "Salary",
      creditos: "Credits exceeded",
      otras_remuneraciones: "Other remuneration",
      pais: "Country",
      poblacion: "Population/Province",
      poblacion_only: "Population",
      provincia: "Province",
      sector: "Company Sector",
      categoria: "Category",
      area_funcional: "Functional Area",
      seleccione_provincia: "-Select a province-",
      sede: "Headquarters/Campus",
      beca: "Monthly Scholarship",
      descripcion_puesto: "Job Description",
      tarea: "Task",
      tutores_disponibles: "Available tutors",
      otras_tareas: "Other tasks",
      programa_practicas: "Internship program",
      aviso_programa: "Important to check to check mandatory requirements",
      enlace_inscripcion: "Registration Link",
      ir_enlace: "Go to link",
      idiomas: "Languages",
      anadir_idiomas: "Add Languages",
      empleo: "Employment",
      practicas: "Internship",
      certificacion: "Minimum certification required",
      requerido: "Required",
      estudios_obligatorios: "Studies to which it is directed",
      estudios_deseables: "Desirable studies",
      estudios_propuestos: "Proposed studies",
      requisitos_obligatorios: "Mandatory requirements",
      etiquetas: "Tags",
      otros_obligatorios: "Other Obligatory",
      edad_maxima: "Maximum age",
      salario_maximo: "Maximum Salary",
      intereses_deseables: "Desirable interests",
      intereses_obligatorios: "Mandatory interest",
      intereses_seleccionados: "Selected interests",
      competencias_obligatorias: "Mandatory competencies",
      competencias_seleccionadas: "Selected competencies",
      paises_nacionalidad_obigatorios: "Countries of Nationality required",
      paises_residencia_obligatorios: "Mandatory Countries of Residence",
      provincia_residencia_obligatorios: "Province of Residence Mandatory",
      paises_seleccionados: "Selected countries",
      provincias_seleccionados: "Selected provinces",
      coche_propio: "Own car",
      obligatorio_quest: "Obligatory?",
      carnet_conducir: "Driver's license",
      disponible_extranjero: "Availability to work abroad",
      disponible_residencia: "Availability for change of residence",
      trabajando_actualmente: "Working Currently",
      requisitos_deseables: "Desirable requirements",
      otros_requisitos_deseables: "Other Desirable Requirements",
      otros_requisitos_obligatorios: "Other mandatory requirements",
      motivos_exclusion: "Reasons for exclusion",
      competencias_deseables: "Desirable competencies",
      paises_nacionalidad_deseables: "Desirable Nationality Countries",
      paises_residencia_deseables: "Desirable Countries of Residence",
      provincia_residencia_deseables: "Desirable Province of Residence",
      programas_informaticos: "Software",
      programas_informaticos_deseables: "Desirable software",
      documentos_requeridos: "Required Documents",
      documentos: "Documents",
      marca_documentos: "Mark the documents that candidates must provide.",
      anadir_otro_documento: "Add another document type",
      nombre_documento_candidato:
        "Name of the document to be provided by the candidate",
      inscribirme: "Register",
      desinscribirme: "Unsubscribe",
      ya_inscrito: "You are already enrolled",
      cancelar_inscripcion: "Unenroll",
      buscar_mas_intereses: "Find more interests",
      atencion: "Attention!",
      tramitar_inscripcion:
        "To process your registration for this offer, you must submit your application on the website of the offering company.",
      acceder: "To access",
      pincha_aqui: "Click here.",
      especialidad: "Specialization",
      estado: "Situation",
      datos_practica: "Practice data",
      paso_4: "Step 4 of 4",
      tareas_a_desarrollar: "Tasks to be carried out",
      horario: "Schedule",
      horario_practicas: "Internship schedule",
      horario_trabajo: "Working time",
      tengo_candidato: "I have a candidate",
      horas_dia: "Hours per day",
      horas_semana: "Weekly hours",
      remuneracion: "Remuneration (€ gross/hour)",
      remuneracion_anual: "Annual gross remuneration",
      otros_beneficios: "Other benefits",
      fecha_inicio: "Start Date",
      fecha_fin: "End date",
      fecha_alta: "Discharge Date",
      duracion_meses: "Duration (in months)",
      dedicacion: "Dedication (% of working hours)",
      departamento: "Department",
      modalidad: "Modality",
      numero_dias_semana: "Number of days per week",
      dias_semana: "Days of the week",
      vinculado_tfg: "Linked to TFG",
      nombre_tfg: "Name TFG",
      tutor_tfg: "TFG Tutor",
      solicitante: "Service Requester",
      centro_practicas: "Internship Center",
      n_pedido: "Order number (if required)",
      observaciones: "Remarks",
      direccion: "Address",
      nombre_tutor_uni: "Name and surname of the University tutor",
      datos_tutor_empresa: "Details of the tutor in the company",
      nombre: "Name",
      apellidos: "Surnames",
      email: "Email",
      telefono: "Telephone",
      cargo: "Charge",
      dni: "Id",
      titulacion_especialidad: "Qualification or speciality",
      titulacion: "Qualifications/Position",
      selecciona: "-Select-",
      nombre_oferta: "Offer Name",
      numero_plazas: "Number of places",
      experiencia_requerida: "Experience Required",
      experiencia_deseable: "Desirable experience",
      opciones_publicacion: "Publishing options",
      url_inscripcion: "Company registration URl",
      candidato_preferido: "Preferred Candidate",
      datos_realizacion: "Internship data",
      conocimientos_especificos: "Specific knowledge",
      formacion_adquirida: "Acquired training",
      seguimiento_previsto: "Planned follow-up",
      empresa_destino:
        "Target company (only if offered by a management/consulting company ETT)",
      datos_tutor: "Company tutor details",
      para_estudiantes_ultimo_ano: "For seniors",
      curso_minimo_requerido: "Minimum course required",
      para_perfil_no_universitario: "For non-university profile",
      activo_quest: "Active?",
      ano_promo_maximo: "Maximum Promotion Year",
      enviar_quest: "Send?",
      candidato_leer: "Candidate to read",
      candidatos_leer: "Candidates to read",
      candidato_total: "Total candidate",
      referencia: "Reference",
      candidatos_total: "Total candidates",
      ver_detalles: "View Details",
      con_practicas: "With assigned practices",
      fecha_caducidad: "Expiration Date",
      buscar_mas_programa: "Find more software",
      programas_elegidos: "Selected software",
      sin_programas: "No specified software",
      selecciona_idioma: "Select a language",
      escribe_idioma: "Enter the language here",
      indica_certificacion:
        "Indicate here the certification or minimum level required",
      titulaciones: "Degrees",
      requeridas: "Required",
      deseables: "Valuable",
      propuestas: "Proposals",
      a_las_que: "to which the offer is directed",
      nivel: "Level",
      areas: "Areas",
      cualquier_area: "Any area",
      ninguna_titulacion: "No titration matches the level filter indicated.",
      eliminar_todas: "Delete all",
      areas_dirige: "Areas targeted by the offer",
      titulaciones_dirige: "Degrees to which the offer is aimed",
      selecciona_titulaciones: "Select the degrees in the list on the left",
      cumplimentar:
        "Complete only if you consider it is relevant information for the candidates.",
      tipo_estudios: "Type of studies",
      seleccione_izquierda: "Select the areas in the list on the left.",
      seleccione_algun_nivel: "Select a level to load the associated areas",
      especialidad_titulacion: "Speciality or qualification",
      puesto_trabajo: "Workstation",
      motivo_rechazo: "Reason for rejection",
      ayuda_estudio: "Study Grants",
      tutor_empresa: "Company Tutor",
      nombre_tutor: "Name of the company tutor",
      apellidos_tutor: "Tutor's surname company",
      email_tutor: "Company tutor email",
      telefono_tutor: "Company tutor's telephone number",
      cargo_tutor: "Position of the company tutor",
      titulacion_tutor: "Qualification of the company tutor",
      departamento_tutor: "Company tutor department",
      dni_tutor: "ID card of the company tutor",
      no_definido: "Not defined",
      candidatos: "Candidates",
      exportar: "Export",
      no_hay_candidatos: "There are no candidates in this offer",
      mas: "more",
      menos: "less",
      empresa_destino_simple: "Destination company",
      tipo_formacion: "Type of education",
      niveles: "Levels",
      areas: "Areas",
      para_estudiantes_ultimo_curso: "For last year students",
      duplicar_oferta_aviso: "Bid duplicated correctly. Want to edit it now?",
      alumno_validado_uib: "Student validated by EUNCET",
      condicionespracticas:
        "I have read and agree to the conditions. <a>See conditions</a>",
      idioma: "Language",
      ofertacerrada:
        "A closed offer will not be visible and will not receive new applicants. Are you sure you want to close this offer?",
      eliminaroferta: "The offer will be removed. Do you want to continue?",
      ofertaduplicada: "Bid duplicated correctly. Want to edit it now?",
      controlCerraroferta:
        "Have you selected any of the candidates proposed by EUNCET?",
      cumplimentainformacion: "Please fill in the following information",
      nombrepersona: "Name and surname of the selected person",
      fechainiciocontrato: "Contract start date",
      tipocontrato: "Type of contract",
      nota_media: "Average grade",
      observaciones: "Comments",
      nombre_apellidos_dni: "Name, surname and Id",
      ocultar_datos_empresa: "Hide company data",
      url_informacion_complementaria: "URL for additional information",
      fichero_informacion_complementaria: "Supplementary information file",
      ver_fichero_adjunto: "See attached file",
      datos_firmante: "Signatory details",
      firmante: {
        nombre: "Signatory's Name",
        apellidos: "Signatory's Last Name",
        email: "Signatory Email",
        dni: "Signatory's ID card",
        cargo: "Signatory's Position",
        telefono: "Telephone",
      },
      num_Pedido: "Order number",
    },
    filtro_oferta: {
      buscar_nombre: "Search by job title",
      buscar_localizacion: "Search by location",
      buscar_titulacion: "Search by degree",
      buscar_puesto: "Search by job title",
      filtro_avanzado: "Advanced Filter",
      cerrar: "Close",
      fecha_publicacion: "Publication date",
      fecha_inicio_previsa: "Expected start date of the internship",
      fecha_inicio: "Start Date",
      filtrado_etiqueta: "Filtering by tags",
      omitir_inscritos: "Skip already enrolled",
      oferta_tfg: "TFG/TFM Offer",
      ofertas_internacional: "International offer",
      ofertas_cv: "Offers that square with my profile/CV",
      busquedas_guardadas: "Saved Searches",
      guardar_busqueda: "Save Search",
      borrar_filtros: "CLEAR FILTERS",
      ver: "See",
      fecha: "Date",
      ofertas_tfg: "TFG/TFM Offer",
      se_han_encontrado: "They have been found",
      introduce_nombre_busqueda: "Enter the name of the search",
      sobreescribe_existente: "or overwrites an existing one",
      selecciona_busqueda: "Select a search",
      ver_historico: "See offer history",
      ver_actuales: "View Current Offers",
      crear_oferta: "CREATE OFFER",
      historico_ofertas: "Offer history",
      no_hay_ofertas: "No offers matching your search",
      solo_con_candidatos: "Only offers with unread candidates",
      tienen_candidatos: "They have candidates",
      caduca_pronto: "Expiring soon",
      no_leidos: "Only unread",
      modalidad: "Modality",
      puesto_Empresa: "Position/ Company",
      buscar_sector: "Search by industry",
    },
    popup_confirmacion: {
      recuerda: "Remember!",
      titulo:
        "Make sure your profile details are up to date before signing up for an offer.",
      actualiza: "Update it by clicking",
      aqui: "here.",
      confirma_titulo:
        "Please confirm that you want to be a candidate in this offer.",
      atencion: "Attention!",
      necesitamos_anadir:
        "We need you to add the following documents in order to register for the offer.",
      url_documento: "Document URl",
      por_favor_adjunta: "Please attach a file or url",
      alumnos_master:
        "Students of a 2-year master's degree must have at least 50% of the credits passed, on the date of the start of the internship, in order to carry them out. Are you a master's student with a duration of less than 2 years, or have you passed 50% of the credits?",
      inscripcion_externa:
        "Registration for this offer is done through the company's website.",
      confirma_inscripcion_externa:
        "Please confirm that you want to be redirected to the company's website to sign up for the offer.",
    },
    header: {
      hola: "Hello",
      oferta_practicas: "Search internship offers",
      oferta_empleo: "Search for job openings",
      propuesta_practicas: "Internship proposal",
      candidaturas: "My Applications",
      practicas: "My internship",
      programas: "Programmes",
      encuestas: "Surveys",
      eventos: "Events",
      mi_cv: "My CV",
      guias_orientacion: "Orientation Guides",
      mis_ofertas: "My offers",
      nueva_oferta: "New offer",
      solicitar_cambio_practicas: "Request Change of Internship",
      documentacion: "Documentation",
      solicitudes_practicas_educacion: "Practical applications education",
      encuestas: "Surveys",
      mi_empresa: "My Company",
      ayuda: "Help",
      cerrar_sesion: "Log out",
      solicitar_baja: "Request Cancellation",
      formulario_datos: "Data form",
    },
    image_uploader: {
      titulo: "Edit profile picture",
    },
    notificaciones: {
      borrar_todo: "Clear All",
      importantes: "Important",
      otras_notificaciones: "Other notifications",
      no_notificaciones: "You don't have any pending notifications",
    },
    popup_borrar_cuenta: {
      titulo:
        "Do you want to unsubscribe from the service and request the deletion of your personal data?",
      si: "Yes",
      no: "No",
    },
    popup_faltan_datos_empresa: {
      atencion: "Attention!",
      cuerpo_1:
        "Mandatory data is missing from your profile, please log in to complete them.",
      cuerpo_2:
        "Mandatory data is missing from your company profile, please log in to complete them.",
      ir_a_perfil: "Go to my Profile",
      ir_a_empresa: "Go to My Company",
    },
    popup_datos_personales: {
      atencion: "Attention!",
      titulo:
        "Mandatory data is missing from your profile, please log in to complete them.",
      ir_a_perfil: "Go to my Profile",
    },
    solicitudes_educacion: {
      titulo:
        "In this section you will find information on students who have applied for internships for your company.",
      zero: "There is no documentation at this time.",
    },
    filtro_candidaturas: {
      buscar_nombre: "Search by job title",
      empleo: "Employment",
      practicas: "Internship",
      filtro_avanzado: "Advanced Filter",
      cerrar: "Close",
      estado: "Status",
      ver: "See",
      borrar_filtros: "CLEAR FILTERS",
      estas_en: "You are in",
      zero: "No selection processes matching your search",
    },
    documentacion: {
      intro:
        "In this section you will find the documentation related to the internships that have been carried out in your company.",
      convenio_titulo: "Partnership agreements",
      caducado: "(Expired) -",
      zero_convenio: "You don't have an agreement yet",
      titulo_convenio:
        "If you wish, you can request and download the collaboration agreement, or provide the document already signed by your company",
      nuevo_convenio: "New agreement",
      subir_convenio: "Upload signed agreement",
      anexos_practicas: "Internship Annexes",
      zero_practicas: "You don't have content yet",
      notas_formativas: "Training notes",
      en: "in",
      otros_documentos: "Other documents associated ",
      zero_documentos: "You do not have any associated document yet",
      otros_documentos_programas: "Other program documents",
      zero_documentos_practicas:
        "Aún no tienes ningún documento asociado a prácticas",
      documentos_aportados_empresa: "Other documents provided by the company",
      no_documentos_anadidos: "No documents added, click to add one",
      anadir_documentacion: "Add documentation",
      selecciona_documento: "Select a document",
      listado_documento: "List of documents",
      otro_tipo_documento: "Other type of document",
      nombre_documento: "Name of document",
      url_documento: "Document URl",
    },
    encuestas: {
      titulo: "Surveys",
      obligatorias: "To continue, answer all the required questions",
      enviar: "Send to ",
      siguiente: "Next",
      empezar_de_nuevo: "Start over",
      pagina: "Page",
      datos_enviados: "Your data has been sent",
      muchas_gracias: "Thanks you so much!!",
      iniciar_sesion: "Sign in with your profile username",
      empresa: "Company",
      candidato: "Candidate",
      usuario: "User",
      contrasena: "Password",
      acceder: "Access",
      o: "Or",
      acceder_anonimamente: "Access anonymously",
      contestar_pregunta: "You must answer this question to continue",
      zero: "No surveys available",
      titulo: "Pending Surveys",
      cuerpo: "Please, before keep gonig, answer these surveys",
      no_puedes:
        "You cannot access the portal until you have answered the pending surveys. If you do not wish to respond at this time, you can log out.",
    },
    eventos: {
      proximos: "Upcoming Events",
      pasados: "Past events",
      evento_destacado: "Featured event",
      desde: "Since",
      hasta: "Until",
      organizado_por: "Organized by",
      inscribirse: "Enroll",
      inscrito: "Registered",
      mas_informacion: "Learn more",
      galeria: "Image Gallery",
      videos: "Videos",
      buscar_localizacion: "Search by location",
      buscar_categoria: "Search by Category",
      buscar_nombre: "Search by name",
      eventos_pasados: "Past events",
      ver_mas: "See more",
    },
    comunicaciones: {
      titulo: "Communications",
    },
    guias: {
      titulo: "Latest orientation guides",
      zero: "No orientation guides",
    },
    ofertas: {
      ultimas_practicas: "Latest internship offers",
      practicas: "Internship",
      ultimas_empleo: "Latest Job Offers",
      empleo: "Employment",
      ofertas: "Offers",
      zero_ofertas: "No offers available.",
      contrato: "Contract",
      idContrato: "Contract",
      salario: "Wage",
      areaFuncional: "Functional Area",
      provincia: "Province",
      areasTitulaciones: "Areas of degrees",
      nivelesTitulaciones: "Degree levels",
      tiposFormacion: "Types of training",
      tituloPrograma: "Program",
      area: "Area",
      filtrar_titulacion: "Filter by Degree",
      tipoModalidadAsistencia: "Modality of assistance",
    },
    cv: {
      nivel: "Level",
      programa_informatico: "Software",
      certificado: "Certificate",
      sin_nivel: "No defined level",
      presentacion: "Presentation",
      anadir_presentacion: "To add your presentation click",
      aqui: "here",
      otros_intereses: "Other interests",
      tus_interes: "Your interests",
      sin_intereses: "No interest specified",
      escribe_interes: "Type down any interest, to start searching",
      click_interes: "Click on the interest to add it",
      click_cambiar_imagen: "Click to change image",
      cambiar_contrasena: "Change password",
      idiomas: "Languages",
      idioma: "Language",
      sin_idiomas: "No languages added, tap Add language to add it",
      idioma_obligatorio:
        "Language and level are required fields to add a language",
      nivel_no_definido: "Level not defined",
      nivel: "Level",
      nombre_certificado: "Certificate Name",
      estancia_extranjero: "Stay abroad",
      pais_estancia: "Country of residence",
      motivo_estancia: "Reason for stay",
      duracion_meses: "Duration in months",
      experiencia_profesional: "Professional experience",
      anadir_nueva_experiencia: "Add new experience",
      sin_experiencia: "No experience",
      nivel_formativo: "Training level",
      actualidad: "Present",
      puesto: "Job Title",
      anadir_documento: "Add Document",
      sector_empresa: "Company Sector",
      area_actividad_puesto: "Position area of activity",
      tipo_contrato: "Type of contract",
      subtipo_contrato: "Contract subtype",
      ver_adjunto: "See attachment",
      ver_enlace: "See link",
      duracion: "Duration",
      fecha_inicio: "Start Date",
      fecha_fin: "End date",
      provincia: "Province",
      empresa: "Company",
      enlace: "Link",
      descripcion_puesto: "Job Description",
      escribe_descripcion: "Write a description of the tasks ",
      anadir_fichero: "Add Attachment",
      adjunto_correctamente: "Attachment correctly",
      isla: "Enclosed Area",
      programas_informaticos: {
        titulo: "Software",
        buscar: "Type to search",
        zero: "No software added, tap add to add",
        anadir: "Add Program",
      },
      sectores_interes: {
        titulo: "Sectors of interest",
        buscar: "Type to search",
        zero: "No sectors of interest added, click on add to add them",
        anadir: "Add sector of interest",
      },
      documentacion_adjunta: "Attached documentation",
      documentacion_subida: "Documentation uploaded on",
      no_hay_documentos: "No documents added",
      pulsa_anadir_documentos: "Tap Add Document to add it",
      anadir_documentacion: "Add documentation",
      selecciona_documento: "Select a document",
      listado_documento: "List of documents",
      otro_tipo_documento: "Other document type",
      nombre_documento: "Document Name",
      url_documento: "Document URl",
      documentacion_privada: "Private documentation",
      no_documentos: "No documents added, tap Add Document to add it",
      documentacion_ligada: "Process-related documentation",
      datos_profesionales: "Professional data",
      visitar: "Visit",
      indica_link_perfil: "Provide a link to your profile",
      trabajando_actualmente: "Working Currently",
      permiso_trabajo: "EU work permission",
      anos_experiencia: "Years of experience",
      sin_experiencia: "No experience",
      disfrutado_erasmus: "I have been on an Erasmus or another mobility grant",
      minima_retribucion: "Minimum remuneration",
      brutos_anuales: "/ annual gross",
      datos_personales: "Personal data",
      dni: "Id",
      fecha_nacimiento: "Date of birth",
      genero: "Gender",
      femenino: "Female",
      masculino: "Male",
      email_personal: "Personal Email",
      email_estudiante: "Student Email",
      avisos_en_email: "Personal Email Notifications",
      acepta_newsletter: "Accept newsletter",
      idioma_comunicaciones: "Preferred language for communications",
      movil: "Mobile",
      fijo: "Landline",
      direccion_empadronamiento: "Registration address",
      direccion_actual: "Current Address",
      direccion: "Address",
      iban: "Nº IBAN ",
      seguridad_social: "Nº Social Security Affiliation",
      pais_nacionalidad: "Country of nationality",
      pais_segunda_nacionalidad: "Second nationality country",
      provincia_nacimiento: "Province of birth",
      provincia: "Province",
      lugar_nacimiento: "Place of birth",
      discapacidad: "Disability greater than 33%",
      deseo_recibir_comunicaciones:
        "I would like to receive communications related to EUNCET and higher education related services.",
      nombre: "Name",
      primer_apellido: "First surname",
      segundo_apellido: "Second surname",
      tipo_identificacion: "Type of Id",
      documento_identidad: "Job Title",
      buscar: "Add Document",
      cp: "Postal code",
      pais: "Country",
      localidad: "Locality",
      tipo_via: "Type of road",
      numero: "Number",
      piso: "Floor",
      puerta: "Door",
      notas: "Notes",
      datos_academicos: "Academic data",
      formacion_complementaria: "Complementary training",
      anadir_titulacion: "Add new degree",
      complementaria: "Complementary",
      centro: "Center",
      nivel_academico: "Academic level",
      tipo: "Guy",
      nota: "Note",
      rama_ensenanza: "Branch of teaching",
      duracion: "Duration",
      actual: "Current",
      si: "Yes",
      no: "No",
      titulo: "Title",
      universidad: "University/Place of Study",
      centro_estudios: "Center where you studied",
      calificacion: "Qualification",
      calificacion_media: "Average degree rating",
      horas: "Hours",
      ambito: "Teaching",
      selecciona_tipo: "- Select a type -",
      certificacion: "Certification",
      tienes_cerfificacion: "Do you have certification?",
      competencias_profesionales: "Professional skills",
      tus_competencias: "Your skills",
      sin_competencias: "No specified professional competencies",
      solicitar_sesion:
        "Do you need help filling out this section? You can request a free orientation session with us by clicking on this <a>link</a> and we will help you.",
      datos_interes: "Interesting facts",
      busqueda_activa_practicas: "Active search for internships",
      busqueda_activa_empleo: "Active job search",
      disponible_extranjero: "Availability to work abroad",
      permiso_conducir: "Driving licence",
      disponible_cambio_residencia: "Available for change of residence",
      coche_propio: "Own car",
      disponible_viajar: "Availability for travel",
      discapacidad_certificada: "Certified Disability",
      carnet_moto: "Motorcycle license",
      moto_propia: "Own motorcycle",
      disponibilidad_jornadas: "Availability of working days",
      periodo_preferencia_practicas: "Internship preference period",
      selecciona: "Select",
      anadir_idioma: "Add Language",
      anadir_intereses: "Add Interest",
      nuevos_datos_academicos: "New academic data",
    },
    addtitulacion: {
      titulo: "Degrees targeted by the offer",
      seleccione_areas: "Select area(s) to filter degrees",
      borrar_areas: "Clear all areas",
      cualquier_area: "Any area",
      escriba_aqui: "Type here to filter the list of degrees below",
      selecciona_titulacion:
        "Select the degree(s) to which the offer is addressed by clicking on it",
      ver_titulaciones: "See bachelor's degrees",
      listadas: "Listed",
      listados: "Listed",
      cualquier_titulacion: "Any of these bachelor's degrees",
      ver_titulaciones_postgrado: "See postgraduate degrees",
      cualquier_titulacion_postgrado: "Any of these postgraduate degrees",
      ver_titulaciones_propio: "See Bachelor's Degree Degrees",
      cualquier_titulacion_propio: "Any of these own degrees",
      lo_sentimos: "Sorry, no titles found matching the search",
      listado_titulaciones_seleccionadas: "List of selected degrees",
      eliminar_titulaciones: "Delete all selected degrees",
    },
    candidato: {
      nuevo: "New",
      pendiente_form_incorporacion: "Pending incorporation form",
      cambiar_estado: "Change status",
      ver_cv: "View CV",
      detalles: "Candidate details",
      selecciona_estado: "Select a state",
      seleccione_motivo: "Please select the candidate's reason for rejecting.",
      cambio_estado: "Change of status",
      descargar_cv: "Download CV",
      cumplimentar_formulario_incorporacion: "Fill out the Incorporation Form",
    },
    cambio_practicas: {
      identifica:
        "Identifies the student for whom they are requesting an extension or variation of their placement conditions.",
      alumno: "Student",
      selecciona_oferta: "Select the offer",
      no_practicas:
        "You don't have any practices yet that you can request a change to.",
      alumno: "Student",
      selecciona_alumno: "Select the student",
      detalles: "Modification Details",
      tipo_modificacion: "Modification Type",
      selecciona_modificacion: "-Select the modification-",
      otros_detalles: "Other details",
      adjunto: "Attached",
      solicitar_cambio: "Request Change",
    },
    popup_idioma: {
      titulo:
        "You're going to change your language preference. Want to continue?",
    },
    formulario_incorporacion: {
      formularioYaCumplimentado:
        "This onboarding form has already been completed. This process requires validation by an EUNCET manager.",
      encabezado:
        "Fill out the onboarding form to complete the student's application and make it selected.",
      persona_de_contacto: "Contact Person",
      contacto_nombre: "Name",
      contacto_apellidos: "Surnames",
      contacto_cargo_departamento: "Position/Department",
      contacto_email: "Email",
      contacto_num_telefono: "Phone number",
      persona_firmante_anexo_convenio: "Signatory of the Annex",
      persona_firmante_convenio_empresa:
        "Person signing the educational cooperation agreement",
      firmante_nombre: "Name",
      firmante_apellidos: "Surnames",
      firmante_cargo_departamento: "Signatory's Title",
      firmante_email: "Email",
      firmante_telefono: "Telephone",
      datos_alumno: "Student Data",
      alumno_dni: "Id",
      alumno_nombre_apellidos: "Name and surname",
      alumno_titulacion: "Titration",
      fecha_inicio: "Start Date",
      fecha_fin: "End date",
      datos_periodo_practicas: "Facts about the Internship Period",
      lugar_realizacion_practicas: "Place of the internship",
      datos_tutor_empresa: "Details of the tutor in the company",
      tutor_nombre: "Name",
      tutor_apellidos: "Surnames",
      tutor_cargo: "Position in Company",
      tutor_email: "Email",
      tutor_dni: "Id",
      tutor_telefono: "Telephone",
      horario: "Timetable",
      num_horas_dia: "Number of hours per day",
      num_horas_semana: "Number of hours per week",
      horas_semana: "Weekly hours",
      retribucion_euros_hora: "Remuneration € gross/hour",
      otras_remuneraciones: "Other remuneration",
      descripcion_actividad:
        "Detailed description of the activity to be carried out by the student (essential to assess and approve its suitability)",
      datos_facturacion: "Billing details",
      info_datos_facturacion:
        "If an order number or purchase order number is required for the management of the invoice for 'management fees of the agreement' of €90+VAT to be issued by Euncet, please indicate below the number",
      num_pedido: "Order number",
      comp_genericas:
        "Generic competencies that the student will work on during the internship",
      compEspecificas: "Specific competencies",
      formaPrevistaSeguimientoOrientacion:
        "Planned Form of Follow-up and Guidance",
      seguimientoDiario: "Daily Tracking",
      reunionesSemanales: "Weekly meetings",
      reunionesPeriodicas: "Regular meetings",
      seguridadSalud: "Health and safety during the internship",
      seguridadSalud_informado:
        "You have been informed about the health and safety aspects that you will have to follow in the company during the internship (delivery of the Risk Identification Document and preventive measures of your position)",
      seguridadSalud_entregado:
        "You have been given personal protective equipment (only if necessary)",
      otros: "Other (Specify)",
      formacionAdquirida: "Training that the student will acquire",
      actividadesTareas: "Activities and tasks that the student has to develop",
      lenguaInglesa: "English Language",
      lenguaInglesa_texto: "Communicate in English with an adequate level of oral and written expression in accordance with the scope of professional intervention",
      comunicacion: "Comunicación", 
      comunicacion_texto: "Communicate orally and in writing with skill and fluency in the language of the professional environment",
      trabajoEquipo: "Teamwork",
      trabajoEquipo_texto: "Work as a team at different levels and with different professionals and institutions related to the business context",
      direccionPersonas: "People management",
      direccionPersonas_texto: "Manage people and professional teams",
      investigacion: "Research and information management", 
      investigacion_texto: "Search and manage business information and critically evaluate the results obtained",
      aprendizajeAutonomo: "Autonomous learning",
      aprendizajeAutonomo_texto: "Learn autonomously",
      autoconocimiento: "Self-knowledge",
      autoconocimiento_texto: "Detect limitations and deficiencies in one's own knowledge and professional skills and be able to overcome them",
      planificacion: "Planning and organization",
      planificacion_texto: "Plan and organize tasks to achieve objectives within established deadlines",
      orientacion: "achievement orientation",
      orientacion_texto: "Identify problems, obstacles and opportunities and know how to propose improvements and find new strategies or solutions",
      empatia: "Empathy and social skills",
      empatia_texto: "Perceive and understand the social situations of the people around you",
      flexibilidad: "Flexibilidad",
      flexibilidad_texto: "Adapt to situations and people in learning and professional contexts",
      pensamientoAnalitico: "Analytical thinking",
      pensamientoAnalitico_texto: "Identify and evaluate situations and problems, separating and organizing their component parts, and reflecting on them in a logical and systematic way."
    },
    popup_aceptaSS: {
      info: "Social Security Information",
      remunerada:
        "As of 1 December 2024, as established by Royal decree 2/2023 (single article ap.34), all students who carry out external academic practices, <strong>both paid internships and unpaid internships</strong> will be <strong>included in the Social Security system</strong>.</br></br>The fulfilment of the obligations of Social Security will always correspond to the company, institution or entity in which the practices are developed, which will assume the condition of the entrepreneur; except in exceptional cases in which the practice is agreed upon by the Faculty of Education and Educational Cooperation Convention.",
      no_remunerada:
        "From 1 January 2024, as established in Royal Decree-Law 2/2023 (sole article ap.34). In the case of unpaid training internships, compliance with Social Security obligations will correspond to the company, institution or entity in which they are carried out, unless the cooperation agreement or cooperation agreement that, where appropriate, is signed for their performance provides that such obligations will correspond to the training centre responsible for the training offer.",
      entendido: "I have read and understood the Social Security obligations",
      aceptar: "Accept",
    },
    politica_privacidad: {
      informacion_usuario: "1. USER INFORMATION",
      responsable_tratamiento:
        "Who is responsible for the processing of your personal data?",
      responsable_tratamiento_text:
        "<b>EUNCET FORMACIÓN SL</b> is RESPONSIBLE for the processing of the USEr's personal data and informs you that this data will be processed in accordance with the provisions of Regulation (EU) 2016/679, of 27 April (RGPD), and Organic Law 3/2018, of 5 December (LOPDGDD).",
      para_que_tratamos: "Why do we process your personal data?",
      para_que_tratamos_text1:
        "The personal data collected will be processed by the RESPONSIBLE for the following purposes",
      para_que_tratamos_text2:
        "Sending commercial advertising communications by e-mail, fax, SMS, MMS, social networks or any other electronic or physical means, present or future, that enable commercial communications. These communications will be carried out by the RESPONSIBLE and will be related to its products and services, or those of its collaborators or suppliers, with whom it has reached a promotional agreement. In this case, third parties will never have access to personal data.",
      para_que_tratamos_text3:
        "Perform market research and statistical analysis.",
      para_que_tratamos_text4:
        "To process orders, requests, respond to queries or any type of request made by the USER through any of the contact forms made available on the CONTROLLEr's website",
      para_que_tratamos_text5:
        "Send the online newsletter about news, offers and promotions RESPONSIBLE.",
      para_que_tratamos_text6: "Treatments derived from teaching activity.",
      para_que_tratamos_text7:
        "Sending, receiving CVs and filling in forms management of personnel selection processes that are or may be enabled by the RESPONSIBLE or by third parties through the platform established for this purpose.",
      para_que_tratamos_text8:
        "Whistleblowing Channel Management. The CONTROLLER has a whistleblowing channel that ensures the right of individuals to report incidents, misconduct and other substantially incorrect behaviour. As provided for in current regulations, these complaints can be anonymous. In the event that the complainant identifies himself, we will process his or her data for the sole purpose of processing the complaint and preparing the corresponding report. Under no circumstances will these data be used for purposes other than the management of the complaint and they will be kept only for the time necessary to carry out the purpose or until there is a legal obligation to keep them.",
      para_que_tratamos_text9:
        "Maintain a relationship between users and the CONTROLLER through their social networks, which may include the following operations: ",
      para_que_tratamos_text10: "To process requests and queries.",
      para_que_tratamos_text11:
        "To report on activities and events organized by the person in charge.",
      para_que_tratamos_text12:
        "To inform about products or services offered by the CONTROLLER.",
      para_que_tratamos_text13: "Interact through official profiles.",
      por_que_tratamos: "Why can we process your personal data?",
      por_que_tratamos_text1:
        "Because the processing is legitimised by Article 6 of the GDPR as follows",
      por_que_tratamos_text2: "With the USEr's consent",
      por_que_tratamos_text3:
        "Sending commercial communications and the newsletter.",
      por_que_tratamos_text4: "Management of personnel selection processes.",
      por_que_tratamos_text5:
        "Maintain a relationship with the RESPOSABLE through their social networks. If the user has a profile on the same social network and has decided to join the RESPOSABLE social network, has shown an interest in the information that is published and, therefore, when requesting to follow our official profiles, they provide us with consent for the processing of the personal data published in their profile.",
      por_que_tratamos_text6:
        "You can at any time access the privacy policies of the social network itself, and configure your profile to ensure your privacy. The RESPONSIBILITY CONTROLLER has access to handle your public information, especially your contact name.",
      por_que_tratamos_text7:
        "For the legitimate interest of the CONTROLLER, to carry out market studies, statistical analysis, processing derived from the teaching activity and to process orders, requests, etc. at the request of the USER.",
      por_que_tratamos_text8:
        "By legal responsabilty management of the complaints channel.",
      por_que_tratamos_text9:
        "Because it is necessary in the execution of a contract for the provision of services and treatments derived from the teaching activity.",
      durante_cuanto_tiempo_tratamos:
        "How long will we store your personal data?",
      durante_cuanto_tiempo_tratamos_text1:
        "They shall be preserved for no longer than is necessary to maintain the purpose of the processing or there are legal prescriptions dictating their safekeeping and when no longer necessary for that purpose, they shall be deleted with appropriate security measures to ensure the anonymisation of the data or their total destruction.",
      a_quien_facilitamos: "Who do we give your personal data to?",
      a_quien_facilitamos_text1:
        "No communication of personal data to third parties is planed to except, if necessary for the development and execution of the purposes of the processing, to our service providers related to communications, with whom the RESPONSIBLE has signed the confidentiality and data processor contracts required by the privacy regulations in force or if there is a legal obligation.",
      a_quien_facilitamos_text2:
        "The data provided when filling in the forms for registration in the personnel selection processes may be communicated to different companies offering internships and/or employment, in order to study your application and, if applicable, the start of the selection process, as well as the maintenance of the candidate's profile (possible sending of communications, confirmation of registration for offers, changes in the status of applications, among others) and to carry out the management of possible job applications.",
      cuales_son_tus_derechos: "What are your rights?",
      cuales_son_tus_derechos_text1: "The rights of the USER are as follows",
      cuales_son_tus_derechos_text2:
        "The right to withdraw consent at any time.",
      cuales_son_tus_derechos_text3:
        "The right of access, rectification, portability and elimination of your data, and the right to limit or oppose its processing.",
      cuales_son_tus_derechos_text4:
        "The right to present a complaint with the supervisory authority (www.aepd.es) if you consider that the processing does not comply with the regulations in force.",
      datos_contacto_derechos: "Contact details to exercise your rights",
      datos_contacto_derechos_text1:
        "EUNCET FORMACIÓN SL. Camí del Mas Rubial, núm. 1 - 08225 Terrassa (Barcelona). E-mail datos@euncet.com",
      datos_contacto_derechos_text2:
        "Contact details of the data protection officer info@badia-adv.com,",
      caracter_obligatorio_o_facultativo:
        "2. MANDATORY OR OPTIONAL NATURE OF THE INFORMATION PROVIDED BY THE USER",
      caracter_obligatorio_o_facultativo_text1:
        "The USER, by way of ticking the corresponding boxes and entering data in the fields, expressly and freely and unequivocally accepts that their data are necessary to deal with their request. The RESPONSIBLE will indicate which data are necessary for the provision of an optimal service to the USER. If such data is not provided, there is no guarantee that the information and services provided will be completely tailored to your needs. The USER guarantees that the personal data provided to the RESPONSIBLE is truthful and is responsible for communicating any changes to it.",
      medidas_de_seguridad: "3. SECURITY MEASURES",
      medidas_de_seguridad_text1:
        "In accordance with the provisions of the regulations in force on personal data protection, the RESPONSIBLE is complying with all the provisions of the RGPD and LOPDGDD regulations for the processing of personal data under its responsibility, and showing up with the principles described in article 5 of the RGPD, whereby they are processed lawfully, fairly and transparently in relation to the data subject and are adequate, relevant and limited to what is necessary in relation to the purposes for which they are processed.",
      medidas_de_seguridad_text2:
        "The RESPONSIBLE guarantees that it has implemented appropriate technical and organisational policies to apply the security measures established by the RGPD and the LOPDGDD in order to protect the rights and freedoms of the USERS and has provided them with the appropriate information to exercise them.",
      medidas_de_seguridad_text3:
        "For more information about privacy guarantees, you can contact the RESPONSIBLE person through EUNCET FORMACIÓN SL. Camí del Mas Rubial, núm. 1 - 08225 Terrassa (Barcelona). E-mail datos@euncet.com",
      medidas_de_seguridad_text4:
        "Contact details of the data protection officer info@badia-adv.com",
    },
    footer: {
      campus: [
        {
          title: "CAMPUS BARCELONA CAN DRAGÓ",
          subtitle: "Nou Barris · Parc Can Dragó",
          direction: "C/ de Rosselló i Pòrcel, 7, 11 A, 08016, Barcelona",
          tel: "937 30 17 43",
        },
        {
          title: "CAMPUS BARCELONA 22@",
          subtitle: "Sant Martí",
          direction: "C/ de Badajoz, 145, Sant Martí, 08018 Barcelona",
          tel: "930 33 33 30",
        },
        {
          title: "CAMPUS TERRASSA",
          subtitle: "Parc de Sant Llorenç del Munt i l'Obac",
          direction: "C/ Camí del Mas Rubial, 1, 08225, Terrassa",
          tel: "935 47 60 66",
        },
      ],
    },
    propuesta_practicas: {
      cabecera_empresas: "If a student is going to do an internship in your company, you can register all the details here. We will evaluate and formalize your proposal if both the internships offered and the selected candidate meet the required requirements.",
      datos_alumno: "Student data",
      introduce_dni: "Enter the candidate's Id",
      dni: "DNI/NIE/Passport",
      validar_candidato: "Validate candidate",
      comprueba_datos: "Check that the candidate's data match. If you have questions, or there is an error, write to us at",
      nombre: "Candidate's name",
      selecciona_titulacion: "Select a degree",
      list_selecciona_titulacion: "Click to select a degree",
      titulacion_candidato: "Qualification of the candidate",
      cabecera_alumno: "If you have found a company in which to carry out your curricular or extracurricular academic internships, you can register it here. We will evaluate it and assign it if it meets all the required requirements..",
      desconocido: 'If you do not know any information, please indicate "unknown"',
      datos_academicos: "Academic data",
      paso_1: "Step 1 of 4",
      paso_2: "Step 2 of 4",
      paso_3: "Step 3 of 4",
      tipo_propuesta: "What type of internship are you going to request/propose?",
      curricular: "Curricular",
      extracurricular: "Extracurricular",
      datos_empresa: "Company details",
      introduce_cif: "Enter the CIF of the company, where you are going to carry out the internship.",
      cif_o_nif: "CIF (company) or NIF (self-employed)",
      validar_empresa: "Validate company",
      comprueba_datos_alumno: "Check that the company data matches the data of the company where you are going to do the internship. If you have a question, or if there is any error, write to us at",
      nombre_empresa: "Company name",
      cif_empresa: "Company cif",
      datos_contacto: "Company contact information",
      introduce_email_contacto: "Enter the email of your contact in the company.", 
      validar_contacto: "Validate contact",
      comprueba_datos_contacto: "Check that the company details match the contact details. If you have a question, or if there is any error, write to us at",
      nombre_contacto: "Contact name",
      email_contacto: "Contact email",
      no_existe_cif: "The CIF provided does not exist in our database, please fill out the following fields.",
      datos_firmante: "Below, enter the information of the legal representative of the company who will sign the agreements:",
      no_exite_contacto: "We do not have data in our database about your contact, please fill in the data.",
    }
  }
};



// WEBPACK FOOTER //
// ./src/translations/index.js